import React from "react";
import { Link } from "react-router-dom";

const PmbokSevenToc = ({ onClose }) => {
  const body = document.querySelector("body")
  body.classList.add("overflow-hidden");
  const closeModal = () => {
    onClose();
    body.classList.remove("overflow-hidden");
  };
  return (
    <div className="text-gray-brand-700">
      <h1 className='resource-title text-2xl font-bold text-center'>Welcome to PMBOK<sup>&reg;</sup> Guide - Sixth Edition!</h1>
      <h2 className='resource-toc font-bold text-center mt-6'>Table of Contents</h2>
      <br />
      <h3 className='resource-section font-bold my-4 font-bold'>A GUIDE TO THE PROJECT MANAGEMENT BODY OF KNOWLEDGE (PMBOK<sup>&reg;</sup> GUIDE)</h3>
      <br />
      <Link className='inline-block resource-sub-fragment level-a disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>1 Introduction</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_1_1_1/7a933391-cf04-48a2-9185-b72de6102a96`} target="_self" onClick={closeModal} >
        <p>1.1 Overview And Purpose Of This Guide</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_1_1_1.1/3bfe9fbd-79d9-43fd-9fed-16a1bc37172c`} target="_self" onClick={closeModal} >
        <p>1.1.1 The Standard For Project Management</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_1_1_1.2/1f0286bc-4a3a-4fd7-b706-9f6033466d01`} target="_self" onClick={closeModal} >
        <p>1.1.2 Common Vocabulary</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_1_1_1.3/2e8841bd-2630-4517-ac17-ded3314a9464`} target="_self" onClick={closeModal} >
        <p>1.1.3 Code Of Ethics And Professional Conduct</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_1_1_2/46e000ce-aba1-4c7e-90d7-35179d2744af`} target="_self" onClick={closeModal} >
        <p>1.2 Foundational Elements</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_1_1_2.1/2ff996de-a459-4237-af91-4f70c814a667`} target="_self" onClick={closeModal} >
        <p>1.2.1 Projects</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_1_1_2.2/7f9783be-074a-479e-a9f1-b5e4a32e73b7`} target="_self" onClick={closeModal} >
        <p>1.2.2 The Importance Of Project Management</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>1.2.3 Relationship of Project, Program, Portfolio, and Operations Management</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_1_2.3.1/95f44ac3-9c1f-427d-9dad-96b70dd21b43`} target="_self" onClick={closeModal} >
        <p>1.2.3.1	Overview</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_1_2.3.2/1d9dc8c1-c0ed-462e-b78b-df34a197beb2`} target="_self" onClick={closeModal} >
        <p>1.2.3.2	Program Management</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_1_2.3.3/23aab85d-f6fb-4bbb-8978-78a691389b25`} target="_self" onClick={closeModal} >
        <p>1.2.3.3	Portfolio Management</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_1_2.3.4/d95b6efa-0810-4d1e-9291-828f2b2893d3`} target="_self" onClick={closeModal} >
        <p>1.2.3.4	Operations Management</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_1_2.3.5/a8912372-08c2-4494-aa9b-6cd0746c2301`} target="_self" onClick={closeModal} >
        <p>1.2.3.5	Operations and Project Management</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_1_2.3.6/46f47884-f004-4c1d-9a3e-6aded1010781`} target="_self" onClick={closeModal} >
        <p>1.2.3.6	Organizational Project Management (OPM) and Strategies</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_1_1_2.4/533a3bf6-9e9c-4856-b2cf-bd644ef3c8f7`} target="_self" onClick={closeModal} >
        <p>1.2.4 Components of the Guide</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_1_2.4.1/e32a4769-6ccc-4aae-9a12-a7be5857fe19`} target="_self" onClick={closeModal} >
        <p>1.2.4.1	Project and Development Life Cycles</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_1_2.4.2/954fb88d-c71a-4ec5-af4f-cfc700db6d8b`} target="_self" onClick={closeModal} >
        <p>1.2.4.2	Project Phase</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_1_2.4.3/966df06b-2f66-44fb-b8b1-89fdc0aa707e`} target="_self" onClick={closeModal} >
        <p>1.2.4.3	Phase Gate</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_1_2.4.4/a54317eb-6fea-4166-9a14-a4127181d425`} target="_self" onClick={closeModal} >
        <p>1.2.4.4	Project Management Processes</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_1_2.4.5/0f78e37e-70e4-4100-b876-dbb842569131`} target="_self" onClick={closeModal} >
        <p>1.2.4.5	Project Management Process Groups</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_1_2.4.6/cd956258-5991-4f2b-a56e-ef2784fb3347`} target="_self" onClick={closeModal} >
        <p>1.2.4.6	Project Management Knowledge Areas</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_1_2.4.7/2199cd3f-8893-469e-acb4-7afea022b342`} target="_self" onClick={closeModal} >
        <p>1.2.4.7	Project Management Data and Information</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_1_1_2.5/040b39de-7d9f-4d3e-bd89-4e648d324b8e`} target="_self" onClick={closeModal} >
        <p>1.2.5 Tailoring</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_1_1_2.6/97109055-6532-4db2-be16-def0a379c948`} target="_self" onClick={closeModal} >
        <p>1.2.6 Project Management Business Documents</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_1_2.6.1/4d2e6dfd-038d-4da3-b1da-ab7e36872f22`} target="_self" onClick={closeModal} >
        <p>1.2.6.1	Project Business Case</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_1_2.6.2/24cc1947-85c8-4c89-8005-f0696451948e`} target="_self" onClick={closeModal} >
        <p>1.2.6.2	Project Benefits Management Plan</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_1_2.6.3/aecd77db-64a1-4fed-900c-5f069d4b214d`} target="_self" onClick={closeModal} >
        <p>1.2.6.3	Project Charter And Project Management Plan</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_1_2.6.4/0f81c78c-9697-42fe-bf4b-aabd2b32bed7`} target="_self" onClick={closeModal} >
        <p>1.2.6.4	Project Success Measures</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-a disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>2 The Environment In Which Projects Operate</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_1_2_1/4a9bc5ac-397c-45d8-9878-63ebc3efaf24`} target="_self" onClick={closeModal} >
        <p>2.1 Overview</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_1_2_2/88423875-c9d2-4cff-9a1e-32b0f01c330b`} target="_self" onClick={closeModal} >
        <p>2.2 Enterprise Environmental Factors</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_1_2_2.1/0333aa70-8d87-4057-aa4d-f491ce32f301`} target="_self" onClick={closeModal} >
        <p>2.2.1 EEFs Internal To The Organization</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_1_2_2.2/62614b2d-174c-4c40-ae0e-08c6eadc58a6`} target="_self" onClick={closeModal} >
        <p>2.2.2 EEFs External To The Organization</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_1_2_3/540b3aaa-3ea2-458a-8340-6826d6c64528`} target="_self" onClick={closeModal} >
        <p>2.3 Organizational Process Assets</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_1_2_3.1/d7804026-9262-42b0-a20e-09dd09c0482f`} target="_self" onClick={closeModal} >
        <p>2.3.1 Processes, Policies, And Procedures</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_1_2_3.2/23f63b26-27a1-4c48-8040-b2291001b69d`} target="_self" onClick={closeModal} >
        <p>2.3.2 Organizational Knowledge Repositories</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>2.4 Organizational Systems</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_1_2_4.1/ffd136fe-f0e9-4117-b460-3d59e8c72b92`} target="_self" onClick={closeModal} >
        <p>2.4.1 Overview</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_1_2_4.2/11358013-73e4-4736-af1e-22aeb25ee871`} target="_self" onClick={closeModal} >
        <p>2.4.2 Organizational Governance Frameworks</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_2_4.2.1/cf72bdbb-8169-413c-a2aa-9d739c8c016a`} target="_self" onClick={closeModal} >
        <p>2.4.2.1	Governance Framework</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_2_4.2.2/eb2124aa-74e1-4b0f-a154-d9ac50fcfdbf`} target="_self" onClick={closeModal} >
        <p>2.4.2.2	Governance Of Portfolios, Programs, And Projects</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_1_2_4.3/437bc6e1-c945-4898-8d99-77a9e0505f67`} target="_self" onClick={closeModal} >
        <p>2.4.3 Management Elements</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_1_2_4.4/0a133694-d3d9-4337-b8aa-7527fbe93d07`} target="_self" onClick={closeModal} >
        <p>2.4.4 Organizational Structure Types</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_2_4.4.1/2c42c0d6-028e-4253-8109-722ac3b79c2d`} target="_self" onClick={closeModal} >
        <p>2.4.4.1	Organizational Structure Types</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_2_4.4.2/b20c6b5f-6cb2-4cdd-95f8-b8e5d2f88ac1`} target="_self" onClick={closeModal} >
        <p>2.4.4.2	Factors In Organization Structure Selection</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_2_4.4.3/b40b29b2-bb48-4acf-9265-57f99f6c509b`} target="_self" onClick={closeModal} >
        <p>2.4.4.3	Project Management Office</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-a disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>3 The Role of the Project Manager</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_1_3_1/5f0d2b4e-0619-4ff9-ac89-d4f28160b94c`} target="_self" onClick={closeModal} >
        <p>3.1 Overview</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_1_3_2/9829e234-4581-47ee-9be0-fc57b08a513b`} target="_self" onClick={closeModal} >
        <p>3.2 Definition Of A Project Manager</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>3.3 The Project Manager's Sphere of Influence</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_1_3_3.1/e0c3b2e7-32cc-42e8-9eeb-daaeb72d2eba`} target="_self" onClick={closeModal} >
        <p>3.3.1 Overview</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_1_3_3.2/329ac661-a263-473b-b02d-8353f8f54d63`} target="_self" onClick={closeModal} >
        <p>3.3.2 The Project</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_1_3_3.3/39ce972a-e985-4afd-be98-117183f09d4c`} target="_self" onClick={closeModal} >
        <p>3.3.3 The Organization</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_1_3_3.4/3103bdc1-c442-4a74-9a4c-8ccdc201217a`} target="_self" onClick={closeModal} >
        <p>3.3.4 The Industry</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_1_3_3.5/5390f448-ca24-4fa3-93a0-97e61909def7`} target="_self" onClick={closeModal} >
        <p>3.3.5 Professional Discipline</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_1_3_3.6/4e498442-f7e4-452a-8a1d-fc0b32564704`} target="_self" onClick={closeModal} >
        <p>3.3.6 Across Discipline</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>3.4 Project Manager Competences</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_1_3_4.1/17f985e6-e093-4032-8355-6be7cdfd2bf6`} target="_self" onClick={closeModal} >
        <p>3.4.1 Overview</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_1_3_4.2/7d0f9528-9109-4824-846d-47f0af4079bf`} target="_self" onClick={closeModal} >
        <p>3.4.2 Technical Project Management Skills</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_1_3_4.3/75c2e13a-0fd4-4215-bc9b-5c1b63c2f712`} target="_self" onClick={closeModal} >
        <p>3.4.3 Strategic And Business Management Skills</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_1_3_4.4/f5400bc5-2b5e-4134-a664-c62866608f3f`} target="_self" onClick={closeModal} >
        <p>3.4.4 Leadership Skills</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_3_4.4.1/0d80ead2-6c3c-4df1-86a1-e118be4f5f72`} target="_self" onClick={closeModal} >
        <p>3.4.4.1	Dealing With People</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_3_4.4.2/bc4cdaf3-a3c1-48b5-a561-1ab9ba304b30`} target="_self" onClick={closeModal} >
        <p>3.4.4.2	Qualities And Skills Of A Leader</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_3_4.4.3/e375a1dc-eca4-4182-b922-bb4416d64d21`} target="_self" onClick={closeModal} >
        <p>3.4.4.3	Politics, Power, And Getting Things Done</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_1_3_4.5/64d8af73-e1a4-4b8b-a8cc-959955c8d2af`} target="_self" onClick={closeModal} >
        <p>3.4.5 Comparison Of Leadership And Management</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_3_4.5.1/d23e1286-3712-4818-a93f-78ebb779da3f`} target="_self" onClick={closeModal} >
        <p>3.4.5.1	Leadership Styles</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_3_4.5.2/4277defa-976a-4764-8d57-d211bc59afb9`} target="_self" onClick={closeModal} >
        <p>3.4.5.2	Personality</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_1_3_5/33c03903-a14d-4e39-832f-b30825813a4e`} target="_self" onClick={closeModal} >
        <p>3.5 Performing Integration</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_1_3_5.1/2ddf18bf-649e-455e-8285-61027f28a0be`} target="_self" onClick={closeModal} >
        <p>3.5.1 Performing Integration At The Process Level</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_1_3_5.2/a1cbdce7-551a-4b43-8004-408feb41c158`} target="_self" onClick={closeModal} >
        <p>3.5.2 Integration At The Cognitive Level</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_1_3_5.3/d4cb28d8-9334-48b9-af71-75bf4a2eec0a`} target="_self" onClick={closeModal} >
        <p>3.5.3 Integration At The Context Level</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_1_3_5.4/2cb1bf34-2d5d-4bce-8d63-8b4348cd34cd`} target="_self" onClick={closeModal} >
        <p>3.5.4 Integration And Complexity</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-a' to={`/posts/pmbok6_1_4_0/bf8a55a8-7d44-4364-9ae8-782841a6d2bb`} target="_self" onClick={closeModal} >
        <p>4 Project Integration Management</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_1_4_1/a7c19c7b-3760-47f1-b73d-ffbef5c043e8`} target="_self" onClick={closeModal} >
        <p>4.1 Develop Project Charter</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>4.1.1 Develop Project Charter: Inputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_1.1.1/ba452d7d-945e-4963-8a0d-b5f746ad8f99`} target="_self" onClick={closeModal} >
        <p>4.1.1.1	Business Documents</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_1.1.2/601fb8bb-1a30-44d3-9ca1-f38a400ce048`} target="_self" onClick={closeModal} >
        <p>4.1.1.2	Agreements</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_1.1.3/9b14a700-641a-41f8-a614-def7417ff392`} target="_self" onClick={closeModal} >
        <p>4.1.1.3	Enterprise Environmental Factors</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_1.1.4/4cf30266-3e07-4e3a-85cb-07b52b21ed92`} target="_self" onClick={closeModal} >
        <p>4.1.1.4	Organizational Process Assets</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>4.1.2 Develop Project Charter: Tools and Techniques</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_1.2.1/756479a9-9b1c-4c97-be4e-bc6a7d09fa43`} target="_self" onClick={closeModal} >
        <p>4.1.2.1	Expert Judgment</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_1.2.2/4cffce5b-dcfc-4bb5-8dd1-6ea566187379`} target="_self" onClick={closeModal} >
        <p>4.1.2.2	Data Gathering</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_1.2.3/ce62c6ca-6da0-499d-9605-b7edf5450377`} target="_self" onClick={closeModal} >
        <p>4.1.2.3	Interpersonal And Team Skills</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_1.2.4/91a1d66d-aaf2-4582-9b5e-57395bae2649`} target="_self" onClick={closeModal} >
        <p>4.1.2.4	Meetings</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>4.1.3 Develop Project Charter: Outputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_1.3.1/67bdacf8-f290-4c02-b027-09cc777635d8`} target="_self" onClick={closeModal} >
        <p>4.1.3.1	Project Charter</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_1.3.2/4fc85eab-3c3c-4e39-8169-77e12a828f82`} target="_self" onClick={closeModal} >
        <p>4.1.3.2	Assumption Log</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_1_4_2/642f0a3e-51b5-47bc-8532-a91fffd8f82c`} target="_self" onClick={closeModal} >
        <p>4.2 Develop Project Management Plan</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>4.2.1 Develop Project Management Plant: Inputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_2.1.1/02fb4278-6d13-48d2-9767-df202e5a4939`} target="_self" onClick={closeModal} >
        <p>4.2.1.1	Project Charter</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_2.1.2/6266ab13-696b-478c-ad6a-12b10cf82530`} target="_self" onClick={closeModal} >
        <p>4.2.1.2	Outputs From Other Processes</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_2.1.3/95af7f7b-21a7-4ae8-957c-8252168a6213`} target="_self" onClick={closeModal} >
        <p>4.2.1.3	Enterprise Environmental Factors</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_2.1.4/3593e69f-5f24-44e4-a2d1-1ce8598b6ff2`} target="_self" onClick={closeModal} >
        <p>4.2.1.4	Organizational Process Assets</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>4.2.2 Develop Project Management Plan: Tools and Techniques</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_2.2.1/a74219bc-e432-4d7f-ae8d-8c50123e5359`} target="_self" onClick={closeModal} >
        <p>4.2.2.1	Expert Judgment</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_2.2.2/004b692a-d7ff-40a6-84d9-ed5948158f1b`} target="_self" onClick={closeModal} >
        <p>4.2.2.2	Data Gathering</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_2.2.3/2f5aa18f-9f18-467f-9050-8ecee2a5fea9`} target="_self" onClick={closeModal} >
        <p>4.2.2.3	Interpersonal And Team Skills</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_2.2.4/406e9d1b-b2e0-4e7b-9496-7784d76a05f4`} target="_self" onClick={closeModal} >
        <p>4.2.2.4	Meetings</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>4.2.3 Develop Project Management Plan: Outputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_2.3.1/dc168674-c1a2-4ddf-bc6c-c6c20cc8d5a6`} target="_self" onClick={closeModal} >
        <p>4.2.3.1	Project Management Plan</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_1_4_3/cda5e359-2a4f-4a44-9c5a-3e0effcbe57c`} target="_self" onClick={closeModal} >
        <p>4.3 Direct And Manage Project Work</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>4.3.1 Direct and Manage Project Work: Inputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_3.1.1/0ee5ab40-11e2-4aea-aeda-07c5891c648d`} target="_self" onClick={closeModal} >
        <p>4.3.1.1	Project Management Plan</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_3.1.2/d490d842-021a-409f-bb6e-f5aa6c932f39`} target="_self" onClick={closeModal} >
        <p>4.3.1.2	Project Documents</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_3.1.3/4d4e317e-5084-44e3-a139-fe1bf3e8d25d`} target="_self" onClick={closeModal} >
        <p>4.3.1.3	Approved Change Requests</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_3.1.4/6c5bc4ea-fcb7-43f2-9db3-cbc36965dd89`} target="_self" onClick={closeModal} >
        <p>4.3.1.4	Enterprise Environmental Factors</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_3.1.5/697c0485-6f83-4962-8b15-51a4c176e183`} target="_self" onClick={closeModal} >
        <p>4.3.1.5	Organizational Process Assets</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>4.3.2 Direct and Manage Project Work: Tools and Techniques</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_3.2.1/774bc768-107f-4fda-a9b8-8dc52b5ffae0`} target="_self" onClick={closeModal} >
        <p>4.3.2.1	Expert Judgment</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_3.2.2/a7a50162-a65e-46b2-88e5-445ef31f00d0`} target="_self" onClick={closeModal} >
        <p>4.3.2.2	Project Management Information System (PMIS)</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_3.2.3/1c24e485-caa5-41ab-8f7a-1aec296efca6`} target="_self" onClick={closeModal} >
        <p>4.3.2.3	Meetings</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>4.3.3 Direct and Manage Project Work: Outputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_3.3.1/71b3ee5a-08aa-41b9-b608-3922f887dac8`} target="_self" onClick={closeModal} >
        <p>4.3.3.1	Deliverables</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_3.3.2/027b4dc7-0e12-4c85-bcdb-e6a20d09caf8`} target="_self" onClick={closeModal} >
        <p>4.3.3.2	Work Performance Data</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_3.3.3/49b514d9-fe00-4eb1-b6c4-e1984e1ce567`} target="_self" onClick={closeModal} >
        <p>4.3.3.3	Issue Log</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_3.3.4/5a93a0a1-b195-4292-9c9b-f2c5ff895a74`} target="_self" onClick={closeModal} >
        <p>4.3.3.4	Change Requests</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_3.3.5/c05fe78d-7c8f-4215-83e8-58fb987ff611`} target="_self" onClick={closeModal} >
        <p>4.3.3.5	Project Management Plan Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_3.3.6/cf425b8f-7801-450c-b802-5f11dbf3beac`} target="_self" onClick={closeModal} >
        <p>4.3.3.6	Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_3.3.7/f903f685-06d1-4f12-b30c-16ead0af7352`} target="_self" onClick={closeModal} >
        <p>4.3.3.7	Organizational Process Assets Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_1_4_4/1a2e46bd-8178-45dd-9b7c-c0f63ce6182a`} target="_self" onClick={closeModal} >
        <p>4.4 Manage Project Knowledge</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>4.4.1 Manage Project Knowledge: Inputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_4.1.1/e3c3330a-74b2-43de-bfc5-469eac46c6f8`} target="_self" onClick={closeModal} >
        <p>4.4.1.1	Project Management Plan</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_4.1.2/36153a29-a397-402e-aca4-4743efc7f74c`} target="_self" onClick={closeModal} >
        <p>4.4.1.2	Project Documents</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_4.1.3/2f2df39d-629d-4186-90c9-20b027e624ad`} target="_self" onClick={closeModal} >
        <p>4.4.1.3	Deliverables</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_4.1.4/2ebd7f89-96fc-429b-bd17-4228887f1dae`} target="_self" onClick={closeModal} >
        <p>4.4.1.4	Enterprise Environmental Factors</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_4.1.5/2e37d74d-bf1d-45ea-888a-357a57ef41ea`} target="_self" onClick={closeModal} >
        <p>4.4.1.5	Organizational Process Assets</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>4.4.2 Manage Project Knowledge: Tools and Techniques</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_4.2.1/36997e05-66d8-4844-ae77-2706f2d6e930`} target="_self" onClick={closeModal} >
        <p>4.4.2.1	Expert Judgment</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_4.2.2/6a77e8e0-9d99-4cd8-9f9c-f352267ef890`} target="_self" onClick={closeModal} >
        <p>4.4.2.2	Knowledge Management</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_4.2.3/20fde3ba-0033-47d0-b1b2-28c045fa073b`} target="_self" onClick={closeModal} >
        <p>4.4.2.3	Information Management</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_4.2.4/60e37377-8b1e-4930-8b33-87695e6bea76`} target="_self" onClick={closeModal} >
        <p>4.4.2.4	Interpersonal And Team Skills</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>4.4.3 Manage Project Knowledge: Outputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_4.3.1/65bba161-1a7d-4545-9b55-9ead0018a3c1`} target="_self" onClick={closeModal} >
        <p>4.4.3.1	Lessons Lenard Register</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_4.3.2/c6fbd91c-bc0f-4e9c-aa20-59d35999718f`} target="_self" onClick={closeModal} >
        <p>4.4.3.2	Project Management Plan Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_4.3.3/a858ad51-ce24-471e-b4e2-a74e9e7dac98`} target="_self" onClick={closeModal} >
        <p>4.4.3.3	Organizational Process Assets Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_1_4_5/586ba5eb-c74a-41e9-b081-fd9e5851c43b`} target="_self" onClick={closeModal} >
        <p>4.5 Monitor And Control Project Work</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>4.5.1 Monitor and Control Project Work: Inputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_5.1.1/e0ea3776-b688-458e-90d6-57a7325bade2`} target="_self" onClick={closeModal} >
        <p>4.5.1.1	Project Management Plan</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_5.1.2/1022fb0c-35d6-478b-aec5-3aba95a559c4`} target="_self" onClick={closeModal} >
        <p>4.5.1.2	Project Documents</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_5.1.3/69ceda6b-ce24-4466-99af-2c8de10e2f8b`} target="_self" onClick={closeModal} >
        <p>4.5.1.3	Work Performance Information</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_5.1.4/553fa3e5-f649-44f1-9485-5fec7eeaf1a7`} target="_self" onClick={closeModal} >
        <p>4.5.1.4	Agreements</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_5.1.5/516be67a-a2df-49c4-a5cc-106ce7f42503`} target="_self" onClick={closeModal} >
        <p>4.5.1.5	Enterprise Environmental Factors</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_5.1.6/0d958972-b031-4db2-9b72-922437e0d372`} target="_self" onClick={closeModal} >
        <p>4.5.1.6	Organizational Process Assets</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>4.5.2 Monitor and Control Project Work: Tools and Techniques</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_5.2.1/22c25ed7-bfc4-4f60-9272-900ab975429e`} target="_self" onClick={closeModal} >
        <p>4.5.2.1	Expert Judgment</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_5.2.2/2acbfc24-ebe3-4a64-8dcc-5b119c77d8d2`} target="_self" onClick={closeModal} >
        <p>4.5.2.2	Data Analysis</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_5.2.3/162afc49-f6de-43c0-9574-d29c9d7b9bac`} target="_self" onClick={closeModal} >
        <p>4.5.2.3	Decision Making</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_5.2.4/e0fb9cdd-aadb-4a11-a27f-b3ca01155318`} target="_self" onClick={closeModal} >
        <p>4.5.2.4	Meetings</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>4.5.3 Monitor and Control Project Work: Outputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_5.3.1/1985bcd3-2e29-4fba-b8c5-5e6ab411963f`} target="_self" onClick={closeModal} >
        <p>4.5.3.1	Work Performance Reports</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_5.3.2/75393035-b3c5-4942-a647-a56957315924`} target="_self" onClick={closeModal} >
        <p>4.5.3.2	Change Requests</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_5.3.3/ac4ba7ef-6b4b-4e41-a7e9-9e97a0d5e63c`} target="_self" onClick={closeModal} >
        <p>4.5.3.3	Project Management Plan Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_5.3.4/d60655a4-5b5c-4d35-9d66-46e6ac6188e4`} target="_self" onClick={closeModal} >
        <p>4.5.3.4	Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_1_4_6/19b70114-06de-43fd-92f9-b10b7fbfc677`} target="_self" onClick={closeModal} >
        <p>4.6 Perform Integrated Change Control</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>4.6.1 Perform Integrated Change Control: Inputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_6.1.1/b38574f9-2e15-48de-80e8-4d0f60db30b6`} target="_self" onClick={closeModal} >
        <p>4.6.1.1	Project Management Plan</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_6.1.2/9feebae6-d584-4a75-9d71-c2a7db9aaeba`} target="_self" onClick={closeModal} >
        <p>4.6.1.2	Project Documents</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_6.1.3/47ebf7b3-06bd-47df-a00e-989cd1d1d774`} target="_self" onClick={closeModal} >
        <p>4.6.1.3	Work Performance Reports</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_6.1.4/c77450e4-2e13-45b3-b3af-64e07c12af24`} target="_self" onClick={closeModal} >
        <p>4.6.1.4	Change Requests</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_6.1.5/e8948b01-88eb-474f-8bf0-744cb0490217`} target="_self" onClick={closeModal} >
        <p>4.6.1.5	Enterprise Environmental Factors</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_6.1.6/8e2eba3e-8f68-44ae-9fed-bb97d822a543`} target="_self" onClick={closeModal} >
        <p>4.6.1.6	Organizational Process Assets</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>4.6.2 Perform Integrated Change Control: Tools and Techniques</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_6.2.1/e1805703-5a92-4b33-8f55-02897ff7294d`} target="_self" onClick={closeModal} >
        <p>4.6.2.1	Expert Judgment</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_6.2.2/405f866d-9dca-4041-9fde-cfe71355a289`} target="_self" onClick={closeModal} >
        <p>4.6.2.2	Change Control Tools</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_6.2.3/d0bb5f18-ef28-4060-843e-14409aacb580`} target="_self" onClick={closeModal} >
        <p>4.6.2.3	Data Analysis</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_6.2.4/8aa927dd-784c-4587-850d-ec0da41edd75`} target="_self" onClick={closeModal} >
        <p>4.6.2.4	Decision Making</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_6.2.5/a51bd682-1efc-4f62-ae9d-76767a4cff6e`} target="_self" onClick={closeModal} >
        <p>4.6.2.5	Meetings</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>4.6.3 Perform Integrated Change Control: Outputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_6.3.1/5aeb5bc4-caa2-42d8-a546-f01fd7bd5c04`} target="_self" onClick={closeModal} >
        <p>4.6.3.1	Approved Change Requests</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_6.3.2/f747afe8-eb6e-479b-8870-4761ef2b97bb`} target="_self" onClick={closeModal} >
        <p>4.6.3.2	Project Management Plan Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_6.3.3/64850794-0085-4ee1-a9a0-b25ca4d7a7f3`} target="_self" onClick={closeModal} >
        <p>4.6.3.3	Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_1_4_7/19163b4e-71de-4557-b580-5f4f6fac3106`} target="_self" onClick={closeModal} >
        <p>4.7 Close Project Or Phase</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>4.7.1 Close Project or Phase: Inputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_7.1.1/85e236d5-addd-4c19-ba93-8eea8403ec69`} target="_self" onClick={closeModal} >
        <p>4.7.1.1	Project Charter</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_7.1.2/24d3d5c1-8b5c-44bf-b1a3-dd8a07815e0d`} target="_self" onClick={closeModal} >
        <p>4.7.1.2	Project Management Plan</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_7.1.3/be91f0be-9417-43ad-be5b-1745052912a7`} target="_self" onClick={closeModal} >
        <p>4.7.1.3	Project Documents</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_7.1.4/99a5f26c-0534-4fd3-b653-60a986e0b4d8`} target="_self" onClick={closeModal} >
        <p>4.7.1.4	Accepted Deliverables</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_7.1.5/c7513d03-f029-436d-a26d-683b6b2a736d`} target="_self" onClick={closeModal} >
        <p>4.7.1.5	Business Documents</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_7.1.6/90e10cb4-a97e-41cf-8beb-0375fe26cb29`} target="_self" onClick={closeModal} >
        <p>4.7.1.6	Agreements</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_7.1.7/34e33797-5e2b-4138-bff4-c1d3959f5cec`} target="_self" onClick={closeModal} >
        <p>4.7.1.7	Procurement Documentation</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_7.1.8/b2bc65a1-10d6-4a55-91d3-2fd40829c86c`} target="_self" onClick={closeModal} >
        <p>4.7.1.8	Organizational Process Assets</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>4.7.2 Close Project or Phase: Tools and Techniques</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_7.2.1/42ad8df1-5f51-4902-9d76-61a7f94f0e88`} target="_self" onClick={closeModal} >
        <p>4.7.2.1	Expert Judgment</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_7.2.2/3c43275d-e9c8-4b30-bb3b-3380eafb50b3`} target="_self" onClick={closeModal} >
        <p>4.7.2.2	Data Analysis</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_7.2.3/4a2badb8-ef7e-459b-bff3-b8f32fb9f850`} target="_self" onClick={closeModal} >
        <p>4.7.2.3	Meetings</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>4.7.3 Close Project or Phase: Outputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_7.3.1/91fbf72f-8812-4a9a-b774-bf5c9eb4a435`} target="_self" onClick={closeModal} >
        <p>4.7.3.1	Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_7.3.2/f050ea27-a53c-416d-9f49-b3a1903812a6`} target="_self" onClick={closeModal} >
        <p>4.7.3.2	Final Product, Service, Or Result Transition</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_7.3.3/02cdde84-2de2-4c5f-a2b2-d6d9d3142974`} target="_self" onClick={closeModal} >
        <p>4.7.3.3	Final Report</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_4_7.3.4/f21b5637-4ed3-4cf8-b631-835b4734b51d`} target="_self" onClick={closeModal} >
        <p>4.7.3.4	Organizational Process Asset Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-a' to={`/posts/pmbok6_1_5_0/2c1779b2-0856-4f7e-adcb-b3f59671fc3e`} target="_self" onClick={closeModal} >
        <p>5 Project Scope Management</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_1_5_1/46bbd537-b152-49d0-a901-13352aeacd14`} target="_self" onClick={closeModal} >
        <p>5.1 Plan Scope Management</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>5.1.1 Plan Scope Management: Inputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_1.1.1/3a458f68-9027-4dfd-9925-9ec158a8ae86`} target="_self" onClick={closeModal} >
        <p>5.1.1.1	Project Charter</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_1.1.2/003f7318-bf59-4adb-81d3-7a98cc49b0bd`} target="_self" onClick={closeModal} >
        <p>5.1.1.2	Project Management Plan</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_1.1.3/b9ade78f-7340-4f0f-969e-a96520803b79`} target="_self" onClick={closeModal} >
        <p>5.1.1.3	Enterprise Environmental Factors</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_1.1.4/e0117725-48a4-4f5f-8945-a2f2ab09b399`} target="_self" onClick={closeModal} >
        <p>5.1.1.4	Organizational Process Assets</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>5.1.2 Plan Scope Management: Tools and Techniques</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_1.2.1/a78793f0-f34e-44a9-ae89-d3ce32bf4766`} target="_self" onClick={closeModal} >
        <p>5.1.2.1	Expert Judgment</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_1.2.2/e4b02e18-769c-461a-a25a-c445731c7cd6`} target="_self" onClick={closeModal} >
        <p>5.1.2.2	Data Analysis</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_1.2.3/ebdb9819-b341-4f7d-b7a7-cc782ffd52cb`} target="_self" onClick={closeModal} >
        <p>5.1.2.3	Meetings</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>5.1.3 Plan Scope Management: Outputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_1.3.1/4cb02806-4f72-4d8f-9eba-4d5fcc9d07b6`} target="_self" onClick={closeModal} >
        <p>5.1.3.1	Scope Management Plan</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_1.3.2/202c3237-d2ff-4092-9159-025ef3de78ab`} target="_self" onClick={closeModal} >
        <p>5.1.3.2	Requirements Management Plan</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_1_5_2/778ffdcd-6119-47d4-bedc-ad5dbbab1c49`} target="_self" onClick={closeModal} >
        <p>5.2 Collect Requirements</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>5.2.1 Collect Requirements: Inputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_2.1.1/997346a5-65bc-43d1-9daf-86d07153aeee`} target="_self" onClick={closeModal} >
        <p>5.2.1.1	Project Charter</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_2.1.2/76abaaab-2e75-40d9-9968-7d8328a55d4b`} target="_self" onClick={closeModal} >
        <p>5.2.1.2	Project Management Plan</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_2.1.3/530d56e6-00ca-4682-bf2d-23005fb67476`} target="_self" onClick={closeModal} >
        <p>5.2.1.3	Project Documents</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_2.1.4/b20077ec-fc2e-45b6-8b63-a7d14a400b49`} target="_self" onClick={closeModal} >
        <p>5.2.1.4	Business Documents</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_2.1.5/4a2cb1b5-4895-479a-80fe-d34f6428f5e2`} target="_self" onClick={closeModal} >
        <p>5.2.1.5	Agreements</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_2.1.6/88850a0a-6922-4d37-bfba-7b2490e7b31b`} target="_self" onClick={closeModal} >
        <p>5.2.1.6	Enterprise Environmental Factors</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_2.1.7/ca7befc9-8055-4dbe-a9c2-0db339b269f0`} target="_self" onClick={closeModal} >
        <p>5.2.1.7	Organizational Process Assets</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>5.2.2 Collect Requirements: Tools and Techniques</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_2.2.1/eb9fe855-a9f3-413e-84df-6e8ffddfd34d`} target="_self" onClick={closeModal} >
        <p>5.2.2.1	Expert Judgment</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_2.2.2/da568b10-878b-4644-a6ee-7c76f747c23c`} target="_self" onClick={closeModal} >
        <p>5.2.2.2	Data Gathering</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_2.2.3/b273bb3e-9a24-4168-845e-6b0e89901a8a`} target="_self" onClick={closeModal} >
        <p>5.2.2.3	Data Analysis</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_2.2.4/9c9f2f31-6039-4eef-907f-eeeffb8ccc82`} target="_self" onClick={closeModal} >
        <p>5.2.2.4	Decision Making</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_2.2.5/cdec92e9-569b-4b14-91ad-341965f24a76`} target="_self" onClick={closeModal} >
        <p>5.2.2.5	Data Representation</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_2.2.6/90ea2bac-648f-4664-bc2d-27db36dc56e9`} target="_self" onClick={closeModal} >
        <p>5.2.2.6	Interpersonal And Team Skills</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_2.2.7/8cf2ba6b-f154-4560-b70c-b60321324d47`} target="_self" onClick={closeModal} >
        <p>5.2.2.7	Context Diagram</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_5.2.8/aa5006a6-48a0-4b52-bc8e-c8d21e926000`} target="_self" onClick={closeModal} >
        <p>5.2.2.8	Prototypes</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>5.2.3 Collect Requirements: Outputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_2.3.1/55a55e6e-f77f-42ec-bf2a-8c54263be162`} target="_self" onClick={closeModal} >
        <p>5.2.3.1	Requirements Documentation</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_2.3.2/aaf2c9e8-d947-4dd9-a0a7-67be29c88740`} target="_self" onClick={closeModal} >
        <p>5.2.3.2	Requirements Traceability Matrix</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_1_5_3/2b3d6e57-f05c-4195-be72-3646ef53e32e`} target="_self" onClick={closeModal} >
        <p>5.3 Define Scope</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>5.3.1 Define Scope: Inputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_3.1.1/08c45bf8-1fa3-45de-8e2c-acd5ae1d636f`} target="_self" onClick={closeModal} >
        <p>5.3.1.1	Project Charter</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_3.1.2/5c9ffb48-9a2a-493a-be40-105109fbaf18`} target="_self" onClick={closeModal} >
        <p>5.3.1.2	Project Management Plan</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_3.1.3/fdc840d1-60c4-46bb-847e-c24e18ea3cf0`} target="_self" onClick={closeModal} >
        <p>5.3.1.3	Project Documents</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_3.1.4/47e0d830-d8d8-4f57-af3c-26be9d0b2f33`} target="_self" onClick={closeModal} >
        <p>5.3.1.4	Enterprise Environmental Factors</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_3.1.5/37bb98ca-b2e6-4f5b-b3fd-07d7ba282bbc`} target="_self" onClick={closeModal} >
        <p>5.3.1.5	Organizational Process Assets</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>5.3.2 Define Scope: Tools and Techniques</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_3.2.1/054231f5-0270-4cfc-8afc-c2688f135c20`} target="_self" onClick={closeModal} >
        <p>5.3.2.1	Expert Judgment</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_3.2.2/3baa6a5a-f99a-45c2-9227-dc6b24bd3920`} target="_self" onClick={closeModal} >
        <p>5.3.2.2	Data Analysis</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_3.2.3/71461bbd-d731-41db-b6a2-ce168f2f5ea1`} target="_self" onClick={closeModal} >
        <p>5.3.2.3	Decision Making</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_3.2.4/1825b839-b593-4605-b2d6-48ef3efc98c4`} target="_self" onClick={closeModal} >
        <p>5.3.2.4	Interpersonal And Team Skills</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_3.2.5/e7795b0f-8ffc-4378-9dd9-bb9308202dab`} target="_self" onClick={closeModal} >
        <p>5.3.2.5	Product Analysis</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>5.3.3 Define Scope: Outputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_3.3.1/d1f9996b-22fa-4314-b2c6-f8c41bed369f`} target="_self" onClick={closeModal} >
        <p>5.3.3.1	Project Scope Statement</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_3.3.2/fb3ad279-4415-4cee-8e68-1f02905c131c`} target="_self" onClick={closeModal} >
        <p>5.3.3.2	Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_1_5_4/23a6bfaa-be95-44ce-9bea-b574b9ffa72d`} target="_self" onClick={closeModal} >
        <p>5.4 Create WBS</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>5.4.1 Create WBS: Inputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_4.1.1/51234d02-0140-4e4b-b8ea-c08de0646a02`} target="_self" onClick={closeModal} >
        <p>5.4.1.1	Project Management Plan</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_4.1.2/bc335c01-8935-40e3-b568-07e89b0d4dfa`} target="_self" onClick={closeModal} >
        <p>5.4.1.2	Project Documents</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_4.1.3/0525ee23-013a-4c02-ba0a-94fd8f227efa`} target="_self" onClick={closeModal} >
        <p>5.4.1.3	Enterprise Environmental Factors</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_4.1.4/d816232f-8565-4efe-82e0-baa366ef9419`} target="_self" onClick={closeModal} >
        <p>5.4.1.4	Organizational Process Assets</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>5.4.2 Ceate WBS: Tools and Techniques</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_4.2.1/9d5c895c-69f1-407f-993f-5ca20747f8da`} target="_self" onClick={closeModal} >
        <p>5.4.2.1	Expert Judgment</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_4.2.2/4c6962c9-d4de-48f1-83d3-3911f7b5315d`} target="_self" onClick={closeModal} >
        <p>5.4.2.2	Decomposition</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>5.4.3 Create WBS: Outputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_4.3.1/ce33d169-b171-42b1-8b0f-7de965cd7495`} target="_self" onClick={closeModal} >
        <p>5.4.3.1	Scope Baseline</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_4.3.2/b645c6f5-cfa1-46ac-bf82-0dd5a87fa42f`} target="_self" onClick={closeModal} >
        <p>5.4.3.2	Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_1_5_5/944242c0-8ad8-4971-9049-df7bc3d296df`} target="_self" onClick={closeModal} >
        <p>5.5 Validate Scope</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>5.5.1 Validate Scope: Inputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_5.1.1/ba04d13b-92ac-4d57-8a0c-b4ea2f274da2`} target="_self" onClick={closeModal} >
        <p>5.5.1.1	Project Management Plan</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_5.1.2/674d7424-4e95-498a-b643-edd2dcd96e1e`} target="_self" onClick={closeModal} >
        <p>5.5.1.2	Project Documents</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_5.1.3/0bf4cb89-c602-4f88-8153-94f7678c28b5`} target="_self" onClick={closeModal} >
        <p>5.5.1.3	Verified Deliverables</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_5.1.4/84e1214e-f195-47cd-a936-5ce92d4a68da`} target="_self" onClick={closeModal} >
        <p>5.5.1.4	Work Performance Data</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>5.5.2 Validate Scope: Tools and Techniques</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_5.2.1/ae0d83c0-270a-4aa2-83ae-5face41271a2`} target="_self" onClick={closeModal} >
        <p>5.5.2.1	Inspection</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_5.2.2/f158f008-eded-403a-bf58-c42af4338f06`} target="_self" onClick={closeModal} >
        <p>5.5.2.2	Decision Making</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>5.5.3 Validate Scope: Outputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_5.3.1/077648f3-c82d-4186-aefb-4160255ce3aa`} target="_self" onClick={closeModal} >
        <p>5.5.3.1	Accepted Deliverables</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_5.3.2/7c00a0ab-33c9-4eea-82e2-2cf23eb0b9a6`} target="_self" onClick={closeModal} >
        <p>5.5.3.2	Work Performance Information</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_5.3.3/7d502c51-c497-435b-9c24-de1cf1c4104e`} target="_self" onClick={closeModal} >
        <p>5.5.3.3	Change Requests</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_5.3.4/b37b0597-7033-43c1-b351-a98e1ee2142b`} target="_self" onClick={closeModal} >
        <p>5.5.3.4	Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_1_5_6/da6fad32-baac-4366-882d-4ba4ebfd7440`} target="_self" onClick={closeModal} >
        <p>5.6 Control Scope</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>5.6.1 Control Scope: Inputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_6.1.1/076ccf9e-ff0a-42f6-898e-a1761f113f84`} target="_self" onClick={closeModal} >
        <p>5.6.1.1	Project Management Plan</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_6.1.2/bf60b4cc-2da3-4aa0-ade2-a3b29f7a9ddb`} target="_self" onClick={closeModal} >
        <p>5.6.1.2	Project Documents</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_6.1.3/1c00776c-97b4-458d-94da-79527691fced`} target="_self" onClick={closeModal} >
        <p>5.6.1.3	Work Performance Data</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_6.1.4/5713d216-3c0c-4880-8b92-c84d0ded09a6`} target="_self" onClick={closeModal} >
        <p>5.6.1.4	Organizational Process Assets</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>5.6.2 Control Scope: Tools and Techniques</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_6.2.1/8532e374-759c-4a7e-986c-377a7e34edf7`} target="_self" onClick={closeModal} >
        <p>5.6.2.1	Data Analysis</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>5.6.3 Control Scope: Outputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_6.3.1/d8396ac9-dc63-476e-84d2-17b2573ec9da`} target="_self" onClick={closeModal} >
        <p>5.6.3.1	Work Performance Information</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_6.3.2/c570bebb-eea2-466b-b473-23547fa2f175`} target="_self" onClick={closeModal} >
        <p>5.6.3.2	Change Requests</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_6.3.3/0c981b4a-5eb2-4cac-8186-92bcdd30bd82`} target="_self" onClick={closeModal} >
        <p>5.6.3.3	Project Management Plan Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_5_6.3.4/b16347c8-859a-4486-9e2d-d7d8aa42562b`} target="_self" onClick={closeModal} >
        <p>5.6.3.4	Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-a' to={`/posts/pmbok6_1_6_0/81c9f54e-768d-47e0-b200-81a31bf84866`} target="_self" onClick={closeModal} >
        <p>6 Project Schedule Management</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_1_6_1/84268a66-e08c-40b4-8b2f-ec575e17c878`} target="_self" onClick={closeModal} >
        <p>6.1 Plan Schedule Management</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>6.1.1 Plan Schedule Management: Inputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_1.1.1/46081a3b-abd1-4a13-8b6b-214b77beb3e6`} target="_self" onClick={closeModal} >
        <p>6.1.1.1	Project Charter</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_1.1.2/995c4c5e-eb8d-4d2a-95c1-f8db058616ff`} target="_self" onClick={closeModal} >
        <p>6.1.1.2	Project Management Plan</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_1.1.3/1463d201-65f6-4dd3-8bc2-bc54b7154577`} target="_self" onClick={closeModal} >
        <p>6.1.1.3	Enterprise Environmental Factors</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_1.1.4/e041e3db-bafd-40ec-9075-aec788f7b8f3`} target="_self" onClick={closeModal} >
        <p>6.1.1.4	Organizational Process Assets</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>6.1.2 Plan Schedule Management: Tools and Techniques</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_1.2.1/bed9bdbe-ddfe-4788-897e-d6ec20ce6a14`} target="_self" onClick={closeModal} >
        <p>6.1.2.1	Expert Judgment</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_1.2.2/bd027cde-4f81-4cee-af10-4755944fc4d3`} target="_self" onClick={closeModal} >
        <p>6.1.2.2	Data Analysis</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_1.2.3/38c1635b-5102-46e7-ab5c-f9b204666b52`} target="_self" onClick={closeModal} >
        <p>6.1.2.3	Meetings</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>6.1.3 Plan Schedule Management: Outputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_1.3.1/1d0b3c7d-d9f9-462d-bae6-f62915c1ae2c`} target="_self" onClick={closeModal} >
        <p>6.1.3.1	Schedule Management Plan</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_1_6_2/68bf3615-e75a-4bbf-862b-3f8c5e2250d7`} target="_self" onClick={closeModal} >
        <p>6.2 Define Activities</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>6.2.1 Define Activities: Inputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_2.1.1/b23f3e3e-a2a7-4d7b-b08d-c0f5b5b22e46`} target="_self" onClick={closeModal} >
        <p>6.2.1.1	Project Management Plan</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_2.1.2/0398d786-f25e-4f14-a546-6eac71f38d04`} target="_self" onClick={closeModal} >
        <p>6.2.1.2	Enterprise Environmental Factors</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_2.1.3/cf6c970d-9b5c-4ae0-9667-7f1ff4c437aa`} target="_self" onClick={closeModal} >
        <p>6.2.1.3	Organizational Process Assets</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>6.2.2 Define Activities: Tools and Techniques</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_2.2.1/2dd91d1c-14ea-46da-8aaa-928c23438858`} target="_self" onClick={closeModal} >
        <p>6.2.2.1	Expert Judgment</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_2.2.2/dbb8512e-ae05-463a-8ea2-412c93905c6b`} target="_self" onClick={closeModal} >
        <p>6.2.2.2	Decomposition</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_2.2.3/f7b7ba50-f487-4136-83f4-095b2cdc4bba`} target="_self" onClick={closeModal} >
        <p>6.2.2.3	Rolling Wave Planning</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_2.2.4/187b94d7-aff3-4bde-b424-b8a13410524c`} target="_self" onClick={closeModal} >
        <p>6.2.2.4	Meetings</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>6.2.3 Define Activities: Outputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_2.3.1/34663950-2e28-4ec3-b441-884f29728ed4`} target="_self" onClick={closeModal} >
        <p>6.2.3.1	Activity List</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_2.3.2/78e788b7-0fd6-47af-b6fd-4eefc8603d36`} target="_self" onClick={closeModal} >
        <p>6.2.3.2	Activity Attributes</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_2.3.3/0f836b37-1453-47f0-8394-da2bbb3ed156`} target="_self" onClick={closeModal} >
        <p>6.2.3.3	Milestone List</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_2.3.4/b5b06db9-df02-49ea-aba1-6f148a2aa40a`} target="_self" onClick={closeModal} >
        <p>6.2.3.4	Change Requests</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_2.3.5/8c4a52d9-0d30-48c2-9b21-c771ca08c55a`} target="_self" onClick={closeModal} >
        <p>6.2.3.5	Project Management Plan Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_1_6_3/afc3c456-d695-4433-ad00-5f80015bf238`} target="_self" onClick={closeModal} >
        <p>6.3 Sequence Activities</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>6.3.1 Sequence Activities: Inputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_3.1.1/70075caa-418a-498b-9b79-b8a6c49f5438`} target="_self" onClick={closeModal} >
        <p>6.3.1.1	Project Management Plan</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_3.1.2/43ebbc26-e56e-4688-868c-baff397f1aa5`} target="_self" onClick={closeModal} >
        <p>6.3.1.2	Project Documents</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_3.1.3/eaffa94a-1ea6-41a6-b947-056e5114b567`} target="_self" onClick={closeModal} >
        <p>6.3.1.3	Enterprise Environmental Factors</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_3.1.4/c1413cf8-2935-4c02-aabc-e9ca9c2aea5a`} target="_self" onClick={closeModal} >
        <p>6.3.1.4	Organizational Process Assets</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>6.3.2 Sequence Activities: Tools and Techniques</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_3.2.1/abccbbda-5d59-47de-a16b-f4205ab80bfa`} target="_self" onClick={closeModal} >
        <p>6.3.2.1	Precedence Diagramming Method</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_3.2.2/26f31159-95f0-480d-9dcd-839bf3300200`} target="_self" onClick={closeModal} >
        <p>6.3.2.2	Dependency Determination and Integration</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_3.2.3/24e7fda5-ff54-4f13-83e1-d56fba026a70`} target="_self" onClick={closeModal} >
        <p>6.3.2.3	Leads and Lags</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_3.2.4/3b6ef7ad-3628-4568-bac8-54c45615e931`} target="_self" onClick={closeModal} >
        <p>6.3.2.4	Project Management Information System (PMIS)</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>6.3.3 Sequence Activities: Outputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_3.3.1/c9dea910-d287-4a23-b78c-02e6d723bbf5`} target="_self" onClick={closeModal} >
        <p>6.3.3.1	Project Schedule Network Diagrams</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_3.3.2/7063dc33-11e9-41bf-acc6-03cbf50ff6d1`} target="_self" onClick={closeModal} >
        <p>6.3.3.2	Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_1_6_4/95013a50-8b6c-411c-8938-029e4592fc81`} target="_self" onClick={closeModal} >
        <p>6.4 Estimate Activity Durations</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>6.4.1 Estimate Activity Durations: Inputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_4.1.1/6327041f-e0ca-4a8c-9468-0446b2c2fc94`} target="_self" onClick={closeModal} >
        <p>6.4.1.1	Project Management Plan</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_4.1.2/3d374b17-3969-4f09-a3fb-02d85a388770`} target="_self" onClick={closeModal} >
        <p>6.4.1.2	Project Documents</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_4.1.3/7e473171-a770-479e-b192-539e685bdb0a`} target="_self" onClick={closeModal} >
        <p>6.4.1.3	Enterprise Environmental Factors</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_4.1.4/510628c2-b968-4981-9408-0fcd539999b4`} target="_self" onClick={closeModal} >
        <p>6.4.1.4	Organizational Process Assets</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>6.4.2 Estimate Activity Durations: Tools and Techniques</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_4.2.1/9e9bbaa1-2746-47b4-84a5-3ac90a110aad`} target="_self" onClick={closeModal} >
        <p>6.4.2.1	Expert Judgment</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_4.2.2/90eb4706-e3d3-426d-bd86-db5ef8004a8e`} target="_self" onClick={closeModal} >
        <p>6.4.2.2	Analogous Estimating</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_4.2.3/16ee5ade-fe24-4de1-811a-e440967526ad`} target="_self" onClick={closeModal} >
        <p>6.4.2.3	Parametric Estimating</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_4.2.4/0253c078-0070-4920-8804-8e6f2e2300ad`} target="_self" onClick={closeModal} >
        <p>6.4.2.4	Three-Point Estimating</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_4.2.5/0d01699e-9a4d-491c-92ae-1c11d981afe0`} target="_self" onClick={closeModal} >
        <p>6.4.2.5	Bottom-Up Estimating</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_4.2.6/2ad69d37-22ce-4d35-a84b-3fc7482e1ced`} target="_self" onClick={closeModal} >
        <p>6.4.2.6	Data Analysis</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_4.2.7/5a714273-b927-4828-b721-dbc4525c654f`} target="_self" onClick={closeModal} >
        <p>6.4.2.7	Decision Making</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_4.2.8/b9b43a9a-9299-4349-8204-ee472ee17ce0`} target="_self" onClick={closeModal} >
        <p>6.4.2.8	Meetings</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>6.4.3 Estimate Activity Durations: Outputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_4.3.1/bb62cee3-d5f4-4e43-9585-16347b5a14e8`} target="_self" onClick={closeModal} >
        <p>6.4.3.1	Duration Estimates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_4.3.2/0f8b9d74-4118-4831-ae96-5181b2d445af`} target="_self" onClick={closeModal} >
        <p>6.4.3.2	Basis Of Estimates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_4.3.3/fb9b76d9-c282-4c2d-b0ee-7d50d1f8333e`} target="_self" onClick={closeModal} >
        <p>6.4.3.3	Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_1_6_5/a6921ff8-ca26-4567-b5ba-b71adca40dbd`} target="_self" onClick={closeModal} >
        <p>6.5 Develop Schedule</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>6.5.1 Develop Schedule: Inputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_5.1.1/1ac99305-2d7c-4c9d-b193-74083cdcff8e`} target="_self" onClick={closeModal} >
        <p>6.5.1.1	Project Management Plan</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_5.1.2/901c717d-ae7f-407b-a14a-bbfad7393e44`} target="_self" onClick={closeModal} >
        <p>6.5.1.2	Project Documents</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_5.1.3/df405115-485a-420a-9332-690db02e9226`} target="_self" onClick={closeModal} >
        <p>6.5.1.3	Agreements</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_5.1.4/ba37e4c5-9098-4be0-a0da-f35b2a351927`} target="_self" onClick={closeModal} >
        <p>6.5.1.4	Enterprise Environmental Factors</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_5.1.5/307a2901-6f44-4dc8-a87f-740bd00e3fbb`} target="_self" onClick={closeModal} >
        <p>6.5.1.5	Organizational Process Assets</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>6.5.2 Develop Schedule: Tools and Techniques</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_5.2.1/310fe7eb-bb2f-41be-898c-2d0601e7c4d4`} target="_self" onClick={closeModal} >
        <p>6.5.2.1	Schedule Network Analysis</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_5.2.2/0224128b-dfeb-4800-8ae5-c2c60ba81c7b`} target="_self" onClick={closeModal} >
        <p>6.5.2.2	Critical Path Method</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_5.2.3/b8ad7c18-1793-4eba-8aef-0bde2ea8d18e`} target="_self" onClick={closeModal} >
        <p>6.5.2.3	Resource Optimization</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_5.2.4/eabaf128-fd91-4981-8f97-cc97ee888b4f`} target="_self" onClick={closeModal} >
        <p>6.5.2.4	Data Analysis</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_5.2.5/b4541210-3449-467b-a303-f2a1778fb8a6`} target="_self" onClick={closeModal} >
        <p>6.5.2.5	Leads and Lags</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_5.2.6/3f6fc62d-a176-4e35-9de8-6fcc62c03118`} target="_self" onClick={closeModal} >
        <p>6.5.2.6	Schedule Compression</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_5.2.7/2def47de-98cd-49d9-a509-68fb9c644d8d`} target="_self" onClick={closeModal} >
        <p>6.5.2.7	Project Management Information System (PMIS)</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_5.2.8/3ea7e786-c2ce-4a44-940f-fd7f61d79b33`} target="_self" onClick={closeModal} >
        <p>6.5.2.8	Agile Release Planning</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>6.5.3 Develop Schedule: Outputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_5.3.1/9c124954-4d61-40fa-82de-5087d459e56a`} target="_self" onClick={closeModal} >
        <p>6.5.3.1	Schedule Baseline</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_5.3.2/ea26fd84-89e1-4d61-9f4b-ff9cd71db8ee`} target="_self" onClick={closeModal} >
        <p>6.5.3.2	Project Schedule</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_5.3.3/ef8279f1-f98c-48ad-9698-53c198bfbad3`} target="_self" onClick={closeModal} >
        <p>6.5.3.3	Schedule Data</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_5.3.4/48f394a3-5a6f-484e-b221-290040ee0dd2`} target="_self" onClick={closeModal} >
        <p>6.5.3.4	Project Calendars</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_5.3.5/ec409d6b-a0af-48c4-a12d-50a3cd14d0d1`} target="_self" onClick={closeModal} >
        <p>6.5.3.5	Change Requests</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_5.3.6/b003e1b7-fc0a-483b-917c-45088f21b5f7`} target="_self" onClick={closeModal} >
        <p>6.5.3.6	Project Management Plan Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_5.3.7/9b0e6bf5-0080-4eb4-9231-9ef5d671200c`} target="_self" onClick={closeModal} >
        <p>6.5.3.7	Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_1_6_6/4bbca448-d656-4e2a-adc5-eacdf2ea99fc`} target="_self" onClick={closeModal} >
        <p>6.6 Control Schedule</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>6.6.1 Control Schedule: Inputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_6.1.1/9865a7f4-18eb-4277-87a3-2c08e6688385`} target="_self" onClick={closeModal} >
        <p>6.6.1.1	Project Management Plan</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_6.1.2/dc7089e9-dbc1-4134-9e92-6114c85d6ab9`} target="_self" onClick={closeModal} >
        <p>6.6.1.2	Project Documents</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_6.1.3/12126cd6-2316-47a0-89c0-4d2ce0e3df0b`} target="_self" onClick={closeModal} >
        <p>6.6.1.3	Work Performance Data</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_6.1.4/12576af3-d86c-4ba4-9156-a3c1618ccb84`} target="_self" onClick={closeModal} >
        <p>6.6.1.4	Organizational Process Assets</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>6.6.2 Control Schedule: Tools and Techniques</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_6.2.1/9c74e2bf-815a-4e69-898e-a0cf49aa0d6d`} target="_self" onClick={closeModal} >
        <p>6.6.2.1	Data Analysis</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_6.2.2/53b687d4-b3db-403c-bc4e-54fbf7eec39b`} target="_self" onClick={closeModal} >
        <p>6.6.2.2	Critical Path Method</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_6.2.3/36821573-ae02-4369-a05c-537164410f6d`} target="_self" onClick={closeModal} >
        <p>6.6.2.3	Project Management Information System (Pmis)</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_6.2.4/5a216e1d-392c-4470-aa19-31d977e1ad7d`} target="_self" onClick={closeModal} >
        <p>6.6.2.4	Resource Optimization</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_6.2.5/23e5d542-ba57-4bda-a620-02ed492ee29d`} target="_self" onClick={closeModal} >
        <p>6.6.2.5	Leads And Lags</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_6.2.6/2861b54e-7413-4a28-b7d1-0cec8dfb0204`} target="_self" onClick={closeModal} >
        <p>6.6.2.6	Schedule Compression</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>6.6.3 Control Schedule: Outputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_6.3.1/562cc79f-9bc7-4a3a-85b3-2bd4a7a192c0`} target="_self" onClick={closeModal} >
        <p>6.6.3.1	Work Performance Information</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_6.3.2/db9755f4-220f-4384-8a54-a4a3803003d1`} target="_self" onClick={closeModal} >
        <p>6.6.3.2	Schedule Forecasts</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_6.3.3/c0c6ecb2-f0fc-4b8e-8c9f-05705c3a3b65`} target="_self" onClick={closeModal} >
        <p>6.6.3.3	Change Requests</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_6.3.4/94745428-3495-4130-995f-adbba49dd792`} target="_self" onClick={closeModal} >
        <p>6.6.3.4	Project Management Plan Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_6_6.3.5/f689b337-be68-42a2-b66f-3c60d9bc685b`} target="_self" onClick={closeModal} >
        <p>6.6.3.5	Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-a' to={`/posts/pmbok6_1_7_0/9619d4d8-15cc-4443-8de3-e498e32a83eb`} target="_self" onClick={closeModal} >
        <p>7 Project Cost Management</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_1_7_1/b22af53b-14cb-4a5b-b3bd-59ad44ed59cc`} target="_self" onClick={closeModal} >
        <p>7.1 Plan Cost Management</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>7.1.1 Plan Cost Management: Inputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_7_1.1.1/b27dc70d-fd10-4d31-b710-851fef9d120b`} target="_self" onClick={closeModal} >
        <p>7.1.1.1	Project Charter</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_7_1.1.2/ecec96b1-3020-4d91-b6e4-504bc9a29659`} target="_self" onClick={closeModal} >
        <p>7.1.1.2	Project Management Plan</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_7_1.1.3/05b0d38f-0d34-4584-9243-ac15d0dad893`} target="_self" onClick={closeModal} >
        <p>7.1.1.3	Enterprise Environmental Factors</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_7_1.1.4/155354e4-2c69-44e4-bba2-597daf65b9dc`} target="_self" onClick={closeModal} >
        <p>7.1.1.4	Organizational Process Assets</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>7.1.2 Plan Cost Management: Tools and Techniques</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_7_1.2.1/cf0b39d4-f499-4893-8454-16b07f6c48e6`} target="_self" onClick={closeModal} >
        <p>7.1.2.1	Expert Judgment</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_7_1.2.2/dea060a0-dd70-48d2-a2f4-59dbbdc6bbc2`} target="_self" onClick={closeModal} >
        <p>7.1.2.2	Data Analysis</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_7_1.2.3/375645e0-08b6-4085-885c-660e14f15747`} target="_self" onClick={closeModal} >
        <p>7.1.2.3	Meetings</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>7.1.3 Plan Cost Management: Outputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_7_1.3.1/b3baadb8-a734-4740-9a0d-cc9c0486b784`} target="_self" onClick={closeModal} >
        <p>7.1.3.1	Cost Management Plan</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_1_7_2/8d5d804d-38a0-453f-97a5-1db64fa826b4`} target="_self" onClick={closeModal} >
        <p>7.2 Estimate Costs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>7.2.1 Estimate Costs: Inputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_7_2.1.1/742edf19-0fd3-4bb5-bd14-303fe16f1e8d`} target="_self" onClick={closeModal} >
        <p>7.2.1.1	Project Management Plan</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_7_2.1.2/0735ffdd-5e85-4c77-a363-7b6fc2dc7151`} target="_self" onClick={closeModal} >
        <p>7.2.1.2	Project Documents</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_7_2.1.3/2feddadf-944e-4997-b1e2-0b3ef575ed14`} target="_self" onClick={closeModal} >
        <p>7.2.1.3	Enterprise Environmental Factors</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_7_2.1.4/992ebb21-e0e9-4d15-abb5-5307796c979f`} target="_self" onClick={closeModal} >
        <p>7.2.1.4	Organizational Process Assets</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>7.2.2 Estimate Costs: Tools and Techniques</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_7_2.2.1/50456e62-bfb0-4393-895c-b57dd0faf83b`} target="_self" onClick={closeModal} >
        <p>7.2.2.1	Expert Judgment</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_7_2.2.2/4a0e4bf0-58df-4ab3-a50e-2d0d378e9b6c`} target="_self" onClick={closeModal} >
        <p>7.2.2.2	Analogous Estimating</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_7_2.2.3/a4e5e2a9-618e-40a1-a77e-c96625114c40`} target="_self" onClick={closeModal} >
        <p>7.2.2.3	Parametric Estimating</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_7_2.2.4/d87341cb-2bb2-4b3d-923d-482d0718acaf`} target="_self" onClick={closeModal} >
        <p>7.2.2.4	Bottom-Up Estimating</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_7_2.2.5/0b521600-951b-429b-ac99-d8111b7076a1`} target="_self" onClick={closeModal} >
        <p>7.2.2.5	Three-Point Estimating</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_7_2.2.6/43de0c83-880e-48f5-a511-b85bbbfb887b`} target="_self" onClick={closeModal} >
        <p>7.2.2.6	Data Analysis</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_7_2.2.7/23827475-7688-435b-bb25-cfb16bb6b849`} target="_self" onClick={closeModal} >
        <p>7.2.2.7	Project Management Information System (Pmis)</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_7_2.2.8/95cf315e-0676-41ef-b6b3-80fbb7faa7a0`} target="_self" onClick={closeModal} >
        <p>7.2.2.8	Decision Making</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>7.2.3 Estimate Costs: Outputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_7_2.3.1/e5c5a11e-fb7e-4d4a-8919-2dce8e217a5f`} target="_self" onClick={closeModal} >
        <p>7.2.3.1	Cost Estimates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_7_2.3.2/7d948d23-8e20-46cf-a620-c5366de47cfe`} target="_self" onClick={closeModal} >
        <p>7.2.3.2	Basis Of Estimates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_7_2.3.3/1e5875a0-f10d-4ccd-a2d2-3c566de68624`} target="_self" onClick={closeModal} >
        <p>7.2.3.3	Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_1_7_3/6dcfa26e-2b89-4acd-bb49-ab869fa51e32`} target="_self" onClick={closeModal} >
        <p>7.3 Determine Budget</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>7.3.1 Determine Budget: Inputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_7_3.1.1/64567156-7b9e-41d9-a1e1-5e680647fe06`} target="_self" onClick={closeModal} >
        <p>7.3.1.1	Project Management Plan</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_7_3.1.2/fe65914c-38b2-4af6-affa-d3fc53c4aef6`} target="_self" onClick={closeModal} >
        <p>7.3.1.2	Project Documents</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_7_3.1.3/0317e2c9-9832-4205-bb73-78ab9b483a7c`} target="_self" onClick={closeModal} >
        <p>7.3.1.3	Business Documents</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_7_3.1.4/8faa261e-0b9a-46dd-ac02-29b3c1ae9bea`} target="_self" onClick={closeModal} >
        <p>7.3.1.4	Agreements</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_7_3.1.5/d2ff4fd4-c71f-4ebe-8153-3b509b405d69`} target="_self" onClick={closeModal} >
        <p>7.3.1.5	Enterprise Environmental Factors</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_7_3.1.6/b725f59d-7e9c-42f5-b07f-85d5319002be`} target="_self" onClick={closeModal} >
        <p>7.3.1.6	Organizational Process Assets</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>7.3.2 Determine Budget: Tools and Techniques</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_7_3.2.1/a1b689be-4c1c-420c-a0a2-c42607c21329`} target="_self" onClick={closeModal} >
        <p>7.3.2.1	Expert Judgment</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_7_3.2.2/438ef726-444d-4e42-b65e-9068894b7bab`} target="_self" onClick={closeModal} >
        <p>7.3.2.2	Cost Aggregation</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_7_3.2.3/593b824d-ad2d-46dd-8d16-6eb998f2ab64`} target="_self" onClick={closeModal} >
        <p>7.3.2.3	Data Analysis</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_7_3.2.4/1c675adc-d800-4ede-b778-1f02e6185ae2`} target="_self" onClick={closeModal} >
        <p>7.3.2.4	Historical Information Review</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_7_3.2.5/1ce617f1-3c51-4e32-b5a5-6eaf25cd4028`} target="_self" onClick={closeModal} >
        <p>7.3.2.5	Funding Limit Reconciliation</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_7_3.2.6/346a9b75-1899-48e4-acfe-23a795cc8413`} target="_self" onClick={closeModal} >
        <p>7.3.2.6	Financing</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>7.3.3 Determine Budget: Outputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_7_3.3.1/b97e4d95-08ad-4bb2-9477-f94789c82be9`} target="_self" onClick={closeModal} >
        <p>7.3.3.1	Cost Baseline</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_7_3.3.2/ccbbafb7-c732-4724-a684-f903399f4cb1`} target="_self" onClick={closeModal} >
        <p>7.3.3.2	Project Funding Requirements</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_7_3.3.3/55fcd685-7111-4d36-9a47-852757b46b52`} target="_self" onClick={closeModal} >
        <p>7.3.3.3	Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_1_7_4/38f57e28-7219-45de-bd55-997cbebe50a7`} target="_self" onClick={closeModal} >
        <p>7.4 Control Costs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>7.4.1 Control Costs: Inputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_7_4.1.1/3eeb7214-9e97-4a91-974c-6832a63d3b6a`} target="_self" onClick={closeModal} >
        <p>7.4.1.1	Project Management Plan</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_7_4.1.2/a7a6700a-4f2a-4ebc-bd1e-f1c67998aa96`} target="_self" onClick={closeModal} >
        <p>7.4.1.2	Project Documents</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_7_4.1.3/424f7006-7ebd-4ef8-9fd6-f1c825e74d0d`} target="_self" onClick={closeModal} >
        <p>7.4.1.3	Project Funding Requirements</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_7_4.1.4/a7628bf6-d7a9-474f-ace6-9771e803b5ae`} target="_self" onClick={closeModal} >
        <p>7.4.1.4	Work Performance Data</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_7_4.1.5/60b14c12-3c01-4f8b-ba6a-1bfd827cd1e9`} target="_self" onClick={closeModal} >
        <p>7.4.1.5	Organizational Process Assets</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>7.4.2 Control Costs: Tool and Techniques</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_7_4.2.1/45487af3-958d-40ec-8726-3344ad8e8bcf`} target="_self" onClick={closeModal} >
        <p>7.4.2.1	Expert Judgment</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_7_4.2.2/73c96d44-942c-4f19-ad46-b77e03d0e631`} target="_self" onClick={closeModal} >
        <p>7.4.2.2	Data Analysis</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_7_4.2.3/aaeec30c-1160-4d12-9d76-36110ff1fd0b`} target="_self" onClick={closeModal} >
        <p>7.4.2.3	To-Complete Performance Index</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_7_4.2.4/718b5295-c7c1-476b-91d2-50ef08c06af0`} target="_self" onClick={closeModal} >
        <p>7.4.2.4	Project Management Information System (Pmis)</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>7.4.3 Control Costs: Outputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_7_4.3.1/39bdab56-906f-4d85-ad54-f3d49d0327de`} target="_self" onClick={closeModal} >
        <p>7.4.3.1	Work Performance Information</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_7_4.3.2/8f27046b-3336-404c-b421-d5dc9ef41c70`} target="_self" onClick={closeModal} >
        <p>7.4.3.2	Cost Forecasts</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_7_4.3.3/77f7cca1-5167-4ce9-b796-2600bcb396ab`} target="_self" onClick={closeModal} >
        <p>7.4.3.3	Change Requests</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_7_4.3.4/43ceaa49-41db-4af0-8fb1-2b5ac02eb53c`} target="_self" onClick={closeModal} >
        <p>7.4.3.4	Project Management Plan Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_7_4.3.5/e40dc940-a726-467c-b149-d87b24eba159`} target="_self" onClick={closeModal} >
        <p>7.4.3.5	Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-a' to={`/posts/pmbok6_1_8_0/01349a03-c903-4609-a5d6-19f3e35fca9a`} target="_self" onClick={closeModal} >
        <p>8 Project Quality Management</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_1_8_1/e2d72f77-6638-44f2-876a-e6a0e677b496`} target="_self" onClick={closeModal} >
        <p>8.1 Plan Quality Management</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>8.1.1 Plan Quality Management: Inputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_8_1.1.1/964c16ed-3dfc-4ac4-a9e0-58fc1c2db748`} target="_self" onClick={closeModal} >
        <p>8.1.1.1	Project Charter</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_8_1.1.2/1445e325-e38b-4c4c-909e-db2ef78a755b`} target="_self" onClick={closeModal} >
        <p>8.1.1.2	Project Management Plan</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_8_1.1.3/4236eeb5-4764-486c-bf86-fde0e35897b2`} target="_self" onClick={closeModal} >
        <p>8.1.1.3	Project Documents</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_8_1.1.4/c20413b7-9a0e-4e20-9b83-220a6b3a7366`} target="_self" onClick={closeModal} >
        <p>8.1.1.4	Enterprise Environmental Factors</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_8_1.1.5/4625c4d2-edd8-4c29-b4c6-2f2e2dcd284a`} target="_self" onClick={closeModal} >
        <p>8.1.1.5	Organizational Process Assets</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>8.1.2 Plan Quality Management: Tools and Techniques</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_8_1.2.1/b2b8c6b8-ca2b-42e0-8041-42c7f7b9e551`} target="_self" onClick={closeModal} >
        <p>8.1.2.1	Expert Judgement</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_8_1.2.2/3a17d788-7f8d-4375-b60c-50157be59c99`} target="_self" onClick={closeModal} >
        <p>8.1.2.2	Data Gathering</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_8_1.2.3/6376d7ce-af2e-4aa3-8ec5-d8e793286eb0`} target="_self" onClick={closeModal} >
        <p>8.1.2.3	Data Analysis</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_8_1.2.4/e8fd5a06-9e90-4b13-aefa-cc8cdae0a6fe`} target="_self" onClick={closeModal} >
        <p>8.1.2.4	Decision Making</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_8_1.2.5/967f192b-0d2a-449a-a92e-fcc6ee4fa2da`} target="_self" onClick={closeModal} >
        <p>8.1.2.5	Data Representation</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_8_1.2.6/e18f7946-6be7-45c5-ba5e-63af03bba1e7`} target="_self" onClick={closeModal} >
        <p>8.1.2.6	Test And Inspect Planning</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_8_1.2.7/08ef67ed-3985-48b6-b949-1f27af5614bc`} target="_self" onClick={closeModal} >
        <p>8.1.2.7	Meetings</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>8.1.3 Plan Quality Management: Outputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_8_1.3.1/2fed96d5-8250-49a4-a001-07de8b308144`} target="_self" onClick={closeModal} >
        <p>8.1.3.1	Quality Management Plan</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_8_1.3.2/45e138f2-f26f-43e8-b875-311c458b9038`} target="_self" onClick={closeModal} >
        <p>8.1.3.2	Quality Metrics</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_8_1.3.3/621277e3-73ab-4298-8fe6-03d6953384aa`} target="_self" onClick={closeModal} >
        <p>8.1.3.3	Project Management Plan Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_8_1.3.4/2ed48a27-ad38-46db-b0fb-5f55b81dee7e`} target="_self" onClick={closeModal} >
        <p>8.1.3.4	Project Document Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_1_8_2/52926ae4-9932-46ad-9fab-1f4e15d3351a`} target="_self" onClick={closeModal} >
        <p>8.2 Manage Quality</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>8.2.1 Manage Quality: Inputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_8_2.1.1/a9a53263-137c-49b8-981d-992f723113ea`} target="_self" onClick={closeModal} >
        <p>8.2.1.1	Project Management Plan</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_8_2.1.2/bfdcf4f8-f066-41db-8a9a-5df241b113e7`} target="_self" onClick={closeModal} >
        <p>8.2.1.2	Project Documents</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_8_2.1.3/1e7c5df8-a8fe-4b85-b8bc-e353631ba478`} target="_self" onClick={closeModal} >
        <p>8.2.1.3	Organizational Process Assets</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>8.2.2 Manage Quality: Tools and Techniques</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_8_2.2.1/993ec848-e12f-4088-ab74-67e6a6b196bf`} target="_self" onClick={closeModal} >
        <p>8.2.2.1	Data Gathering</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_8_2.2.2/aeaf8713-1652-402d-8c2c-6775ec74c585`} target="_self" onClick={closeModal} >
        <p>8.2.2.2	Data Analysis</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_8_2.2.3/2cf6b3d6-925c-4b44-b6d1-98668f19c58b`} target="_self" onClick={closeModal} >
        <p>8.2.2.3	Decision Making</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_8_2.2.4/86750e62-2a30-40f1-85c4-bb2e9ae2abe3`} target="_self" onClick={closeModal} >
        <p>8.2.2.4	Data Representation</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_8_2.2.5/3388bbfd-438c-4520-84dd-2d370c42edab`} target="_self" onClick={closeModal} >
        <p>8.2.2.5	Audits</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_8_2.2.6/33740021-eb31-4e64-8be9-18b10f39756e`} target="_self" onClick={closeModal} >
        <p>8.2.2.6	Design For X</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_8_2.2.7/2f8b4411-3f51-4fe3-998d-cd602f17b968`} target="_self" onClick={closeModal} >
        <p>8.2.2.7	Problem Solving</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_8_2.2.8/8a292359-4eb9-46ab-b745-42c8ab673bf0`} target="_self" onClick={closeModal} >
        <p>8.2.2.8	Quality Improvement Methods</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>8.2.3 Manage Quality: Outputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_8_2.3.1/35c591e7-dcbe-4fc4-a6da-e45b1a38a315`} target="_self" onClick={closeModal} >
        <p>8.2.3.1	Quality Reports</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_8_2.3.2/d87ec56e-a7af-4ac3-9481-952adef07d95`} target="_self" onClick={closeModal} >
        <p>8.2.3.2	Test And Evaluation Documents</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_8_2.3.3/09990035-b955-4ac0-9ab8-81c9599a52b7`} target="_self" onClick={closeModal} >
        <p>8.2.3.3	Change Request</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_8_2.3.4/87be35fc-8783-4a66-87b4-ae06dd325535`} target="_self" onClick={closeModal} >
        <p>8.2.3.4	Project Management Plan Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_8_2.3.5/d4a29089-0752-44ec-ad17-87e85be33dc6`} target="_self" onClick={closeModal} >
        <p>8.2.3.5	Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_1_8_3/ac153156-9c00-44b6-b954-4970949d2de6`} target="_self" onClick={closeModal} >
        <p>8.3 Control Quality</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>8.3.1 Control Quality: Inputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_8_3.1.1/b1abe6a0-e346-45fe-80ab-92d4b919a850`} target="_self" onClick={closeModal} >
        <p>8.3.1.1	Project Management Plan</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_8_3.1.2/5b286a7a-8a8c-4246-bb99-f9da141b9376`} target="_self" onClick={closeModal} >
        <p>8.3.1.2	Project Documents</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_8_3.1.3/67e5d0ec-cc0c-463c-be80-6dfdd32f5249`} target="_self" onClick={closeModal} >
        <p>8.3.1.3	Approved Change Request</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_8_3.1.4/d267b098-b66e-4a2a-9b99-47920117306e`} target="_self" onClick={closeModal} >
        <p>8.3.1.4	Deliverables</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_8_3.1.5/dbfaccef-643a-49ce-8102-390fd4cbc118`} target="_self" onClick={closeModal} >
        <p>8.3.1.5	Work Performance Data</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_8_3.1.6/b4ca925d-dc02-4028-be7d-1e1ce7528b07`} target="_self" onClick={closeModal} >
        <p>8.3.1.6	Enterprise Environmental Factors</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_8_3.1.7/f48330c0-4b53-4378-b0d9-753c8a2f550d`} target="_self" onClick={closeModal} >
        <p>8.3.1.7	Organizational Process Assets</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>8.3.2 Control Quality: Tools and Techniques</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_8_3.2.1/3dba5c6b-20ef-4949-818a-3affd0d2b2a0`} target="_self" onClick={closeModal} >
        <p>8.3.2.1	Data Gathering</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_8_3.2.2/b59d0c7b-1b4c-4b06-9bcb-5899720f24e8`} target="_self" onClick={closeModal} >
        <p>8.3.2.2	Data Analysis</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_8_3.2.3/beecda11-0f23-436d-86e2-c0bed3b7099e`} target="_self" onClick={closeModal} >
        <p>8.3.2.3	Inspection</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_8_3.2.4/b66392c4-85d5-4649-872f-0058ad6a4d49`} target="_self" onClick={closeModal} >
        <p>8.3.2.4	Testing/Product Evaluations</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_8_3.2.5/aed8e742-dad0-461b-9a55-f36b652ad53c`} target="_self" onClick={closeModal} >
        <p>8.3.2.5	Data Representation</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_8_3.2.6/c9c11d88-27da-4b2d-936d-1c92b30ecbac`} target="_self" onClick={closeModal} >
        <p>8.3.2.6	Meetings</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>8.3.3 Control Quality: Outputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_8_3.3.1/e1415402-08d4-45a4-a97e-7972b9277536`} target="_self" onClick={closeModal} >
        <p>8.3.3.1	Quality Control Measurments</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_8_3.3.2/5f9a25fb-99eb-4a5f-9a5d-88bd29aad826`} target="_self" onClick={closeModal} >
        <p>8.3.3.2	Verified Deliverables</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_8_3.3.3/9a1bf1b4-b42a-4ee3-8571-ba248796e36f`} target="_self" onClick={closeModal} >
        <p>8.3.3.3	Work Performance Information</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_8_3.3.4/82adbd75-2d4a-49f3-886d-f700cab3b3f2`} target="_self" onClick={closeModal} >
        <p>8.3.3.4	Change Requests</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_8_3.3.5/72c331b8-6dbb-4b68-b960-25e7f50ef08b`} target="_self" onClick={closeModal} >
        <p>8.3.3.5	Project Management Plan Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_8_3.3.6/dd0a0b86-a68a-4079-8a01-5169201ec2b2`} target="_self" onClick={closeModal} >
        <p>8.3.3.6	Project Document Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-a' to={`/posts/pmbok6_1_9_0/29c0a359-27ee-431a-9cdc-ad461e59e429`} target="_self" onClick={closeModal} >
        <p>9 Project Resource Management</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_1_9_1/f9cf9fe9-f831-4ca9-91d6-934dbb3334d0`} target="_self" onClick={closeModal} >
        <p>9.1 Plan Resource Management</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>9.1.1 Plan Resource Management: Inputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_1.1.1/86a29c9a-a196-4082-9dca-5458ceda220c`} target="_self" onClick={closeModal} >
        <p>9.1.1.1	Project Charter</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_1.1.2/aa55d219-e2fd-4023-b9d6-a40e058798ec`} target="_self" onClick={closeModal} >
        <p>9.1.1.2	Project Management Plan</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_1.1.3/ee182c3a-1052-4bed-b657-ff4f9837a812`} target="_self" onClick={closeModal} >
        <p>9.1.1.3	Project Documents</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_1.1.4/3708b7ed-c3a3-4d07-b7cc-be13c27e59f4`} target="_self" onClick={closeModal} >
        <p>9.1.1.4	Enterprise Environmental Factors</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_1.1.5/be34288f-d526-445a-a7b3-73d847798540`} target="_self" onClick={closeModal} >
        <p>9.1.1.5	Organizational Process Assets</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>9.1.2 Plan Resource Management: Tools and Techniques</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_1.2.1/c7408161-0e6f-4892-81d4-e30d1ba5a9b4`} target="_self" onClick={closeModal} >
        <p>9.1.2.1	Expert Judgment</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_1.2.2/27adbec9-20c6-49d5-95bc-1f6d514858d0`} target="_self" onClick={closeModal} >
        <p>9.1.2.2	Data Representation</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_1.2.3/16b85847-2341-4c3a-804d-4b98256c03d4`} target="_self" onClick={closeModal} >
        <p>9.1.2.3	Organizational Theory</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_1.2.4/4aed09b0-c60c-4d4e-9c10-8f9522a0b4f0`} target="_self" onClick={closeModal} >
        <p>9.1.2.4	Meetings</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>9.1.3 Plan Resource Managements: Outputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_1.3.1/fc8c088c-fc1d-4416-ae5c-8f5e7d6da87d`} target="_self" onClick={closeModal} >
        <p>9.1.3.1	Resource Management Plan</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_1.3.2/a2c7a03a-c281-407c-a0aa-7204ef37a9f6`} target="_self" onClick={closeModal} >
        <p>9.1.3.2	Team Charter</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_1.3.3/76782804-a73a-45b3-b5af-541d968d5c8b`} target="_self" onClick={closeModal} >
        <p>9.1.3.3	Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_1_9_2/6cfed96c-e51f-495e-a311-3a8646a9fb19`} target="_self" onClick={closeModal} >
        <p>9.2 Estimate Activity Resources</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>9.2.1 Estimate Activity Resources: Inputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_2.1.1/203ffee1-4d34-4aff-9566-13bd73d6d500`} target="_self" onClick={closeModal} >
        <p>9.2.1.1	Project Management Plan</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_2.1.2/55c6f1c3-0c13-413c-aee3-51876886a5f5`} target="_self" onClick={closeModal} >
        <p>9.2.1.2	Project Documents</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_2.1.3/2a71d96c-8aa3-47cb-8f69-cac7d9e398e0`} target="_self" onClick={closeModal} >
        <p>9.2.1.3	Enterprise Environmental Factors</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_2.1.4/8ea9fc64-97cb-4ab5-9d3f-2ca67f550032`} target="_self" onClick={closeModal} >
        <p>9.2.1.4	Organizational Process Assets</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>9.2.2 Estimate Activity Resources: Tools and Techniques</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_2.2.1/1bb799f1-ffa7-4bd5-bf8f-d6e842cd4491`} target="_self" onClick={closeModal} >
        <p>9.2.2.1	Expert Judgement</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_2.2.2/f7d94976-bed1-4a91-aaa7-39bbd7cae2eb`} target="_self" onClick={closeModal} >
        <p>9.2.2.2	Bottom-Up Estimating</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_2.2.3/0f76fdda-d2ba-4095-b523-d53a052933e8`} target="_self" onClick={closeModal} >
        <p>9.2.2.3	Analogous Estimating</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_2.2.4/928f8657-b3d3-4691-8e2b-02d827d01cd4`} target="_self" onClick={closeModal} >
        <p>9.2.2.4	Parametric Estimating</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_2.2.5/03ee6893-263c-47b9-a874-fbde8c834e35`} target="_self" onClick={closeModal} >
        <p>9.2.2.5	Data Analysis</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_2.2.6/7ebc3335-c689-4f4a-991e-ae1d408899ec`} target="_self" onClick={closeModal} >
        <p>9.2.2.6	Project Management Information System (Pmis)</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_2.2.7/50cbe7e2-5030-4221-a061-a068684ad3ac`} target="_self" onClick={closeModal} >
        <p>9.2.2.7	Meetings</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>9.2.3 Estimate Activity Resources: Outputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_2.3.1/d850c1ca-cbba-4dac-862c-0987f3149b60`} target="_self" onClick={closeModal} >
        <p>9.2.3.1	Resource Requirements</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_2.3.2/8154672a-20c0-4385-abc3-2666ceba7235`} target="_self" onClick={closeModal} >
        <p>9.2.3.2	Basis Of Estimates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_2.3.3/62e154a4-7268-47d3-b82c-62196de89be4`} target="_self" onClick={closeModal} >
        <p>9.2.3.3	Resource Breakdown Structure</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_2.3.4/eb89f876-26e3-4bf7-a52a-6c4b2fb7670f`} target="_self" onClick={closeModal} >
        <p>9.2.3.4	Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_1_9_3/7f473844-d0c1-4553-bd6b-ebc8247de307`} target="_self" onClick={closeModal} >
        <p>9.3 Acquire Resources</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>9.3.1 Acquire Resources: Inputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_3.1.1/90c4b92b-732e-4614-a9e5-87fe103097ac`} target="_self" onClick={closeModal} >
        <p>9.3.1.1	Project Management Plan</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_3.1.2/57e58f79-87a9-4979-a6f7-0cf85e84e2f5`} target="_self" onClick={closeModal} >
        <p>9.3.1.2	Project Documents</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_3.1.3/6743fe57-6c7e-43de-a7e2-7441cb4aceea`} target="_self" onClick={closeModal} >
        <p>9.3.1.3	Enterprise Environmental Factors</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_3.1.4/ac2d30e6-ea66-4804-a6d9-7b300f7be0bf`} target="_self" onClick={closeModal} >
        <p>9.3.1.4	Organizational Process Assets</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>9.3.2 Acquire Resources: Tools and Techniques</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_3.2.1/1e2e1e3a-0dee-4959-8ba6-e586b1c76820`} target="_self" onClick={closeModal} >
        <p>9.3.2.1	Decision Making</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_3.2.2/9a005590-e4c4-4f3e-9635-2f06b812b9e7`} target="_self" onClick={closeModal} >
        <p>9.3.2.2	Interpersonal And Team Skills</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_3.2.3/127c852c-a599-4282-b2cc-6b956afdc1bf`} target="_self" onClick={closeModal} >
        <p>9.3.2.3	Pre-Assignment</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_3.2.4/b2954669-6666-4793-924c-5c7f5e98546a`} target="_self" onClick={closeModal} >
        <p>9.3.2.4	Virtual Teams</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>9.3.3 Acquire Resources: Outputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_3.3.1/061f6388-87b1-4f24-9a8d-95e97ff6611e`} target="_self" onClick={closeModal} >
        <p>9.3.3.1	Physical Resource Assignments</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_3.3.2/3d960bf3-3cbb-49e8-b993-de21bb54633e`} target="_self" onClick={closeModal} >
        <p>9.3.3.2	Project Team Assignments</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_3.3.3/57c1f7d1-6e43-4287-a8af-9e10528312c4`} target="_self" onClick={closeModal} >
        <p>9.3.3.3	Resource Calendars</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_3.3.4/94528303-87a6-45df-bc56-dd439d6d66de`} target="_self" onClick={closeModal} >
        <p>9.3.3.4	Change Requests</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_3.3.5/ee55ec1a-dffa-40df-af0b-4728cb944359`} target="_self" onClick={closeModal} >
        <p>9.3.3.5	Project Management Plan Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_3.3.6/f2478e98-ba6d-4ba9-ac15-474ee0cf68c5`} target="_self" onClick={closeModal} >
        <p>9.3.3.6	Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_3.3.7/d57f1172-790a-4907-acbd-94ac46b3a393`} target="_self" onClick={closeModal} >
        <p>9.3.3.7	Enterprise Environmental Factors Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_3.3.8/fdd1cc66-4294-4834-8664-a23759e853b3`} target="_self" onClick={closeModal} >
        <p>9.3.3.8	Organizational Process Assets Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_1_9_4/67279997-7a05-4575-8301-6b09434ffdb8`} target="_self" onClick={closeModal} >
        <p>9.4 Develop Team</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>9.4.1 Develop Team: Inputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_4.1.1/75fc1cdb-2cd1-4ed7-bb41-2f8b846d7687`} target="_self" onClick={closeModal} >
        <p>9.4.1.1	Project Management Plan</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_4.1.2/cdbaabb2-ddf4-4024-901c-86d5abfa9c5b`} target="_self" onClick={closeModal} >
        <p>9.4.1.2	Project Documents</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_4.1.3/aa15ec72-2759-4966-9b8e-dd108aba7d64`} target="_self" onClick={closeModal} >
        <p>9.4.1.3	Enterprise Environmental Factors</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_4.1.4/7bc93c98-cfa7-497e-b1c4-3d8a005ac1d7`} target="_self" onClick={closeModal} >
        <p>9.4.1.4	Organizational Process Assets</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>9.4.2 Develop Team: Tools and Techniques</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_4.2.1/b286a308-275d-4b7b-be42-c463252b1d28`} target="_self" onClick={closeModal} >
        <p>9.4.2.1	Colocation</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_4.2.2/e831caa8-0c54-49bc-9fd9-8a0fe43979b3`} target="_self" onClick={closeModal} >
        <p>9.4.2.2	Virtual Teams</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_4.2.3/c35b29a9-263a-4a39-8219-c6fcf57cce15`} target="_self" onClick={closeModal} >
        <p>9.4.2.3	Communication Technology</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_4.2.4/951a0861-ec2a-4602-b4e3-b2e1154cde00`} target="_self" onClick={closeModal} >
        <p>9.4.2.4	Interpersonal And Team Skills</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_4.2.5/9a9eb70d-4b29-4aa6-bcbf-a0179e210057`} target="_self" onClick={closeModal} >
        <p>9.4.2.5	Recognition And Rewards</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_4.2.6/9df06563-843c-41c7-a36f-81f37a9f450b`} target="_self" onClick={closeModal} >
        <p>9.4.2.6	Training</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_4.2.7/8b3c3bdf-0728-4196-ae3e-80045662cf20`} target="_self" onClick={closeModal} >
        <p>9.4.2.7	Individual And Team Assessments</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_4.2.8/b0cf8705-d1ab-4ef9-a965-cd1ac9e27997`} target="_self" onClick={closeModal} >
        <p>9.4.2.8	Meetings</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>9.4.3 Develop Team: Outputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_4.3.1/c363a256-ab16-49dd-b837-75223dfa9109`} target="_self" onClick={closeModal} >
        <p>9.4.3.1	Team Performance Assessments</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_4.3.2/91f75e60-61c6-4897-b315-b64ec536da67`} target="_self" onClick={closeModal} >
        <p>9.4.3.2	Change Requests</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_4.3.3/71cb11e9-63e0-46c7-9478-9056fd6afa21`} target="_self" onClick={closeModal} >
        <p>9.4.3.3	Project Management Plan Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_4.3.4/e204b9c3-2517-4666-863c-c9ced1c7ebe1`} target="_self" onClick={closeModal} >
        <p>9.4.3.4	Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_4.3.5/14d2ef33-600f-44fd-b691-327313659d15`} target="_self" onClick={closeModal} >
        <p>9.4.3.5	Enterprise Environmental Factors Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_4.3.6/0d8e74de-bea4-400c-89a5-280039c4bfe9`} target="_self" onClick={closeModal} >
        <p>9.4.3.6	Organizational Process Assets Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_1_9_5/6a7c964f-f14b-41ea-adf8-ee0d87329eed`} target="_self" onClick={closeModal} >
        <p>9.5 Manage Team</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>9.5.1 Manage Team: Inputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_5.1.1/4f7f087b-761d-435c-8c51-398c730a638a`} target="_self" onClick={closeModal} >
        <p>9.5.1.1	Project Management Plan</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_5.1.2/dc37e66b-10ee-47c8-83e4-0a9f59cfa360`} target="_self" onClick={closeModal} >
        <p>9.5.1.2	Project Documents</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_5.1.3/f8567c58-a196-49ba-93c0-2f1778f595d5`} target="_self" onClick={closeModal} >
        <p>9.5.1.3	Work Performance Reports</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_5.1.4/d3b9614c-af18-4d5d-b050-e3612b07a7bb`} target="_self" onClick={closeModal} >
        <p>9.5.1.4	Team Performance Assessments</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_5.1.5/a71e16ad-182b-4b63-99ab-9a1b9c6ff9c3`} target="_self" onClick={closeModal} >
        <p>9.5.1.5	Enterprise Environmental Factors</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_5.1.6/ad17c85c-fae7-4880-9a57-830561f39e5c`} target="_self" onClick={closeModal} >
        <p>9.5.1.6	Organizational Process Assets</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>9.5.2 Manage Team: Tools and Techniques</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_5.2.1/eb8aec51-1667-4873-93e6-d97a1738cb4a`} target="_self" onClick={closeModal} >
        <p>9.5.2.1	Interpersonal And Team Skills</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_5.2.2/632e679a-99dd-4f49-a61c-792dcf505d2f`} target="_self" onClick={closeModal} >
        <p>9.5.2.2	Project Management Information System (Pmis)</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>9.5.3 Manage Teams: Outputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_5.3.1/443d55fa-bd53-404a-a00f-29d9035e61bc`} target="_self" onClick={closeModal} >
        <p>9.5.3.1	Change Requests</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_5.3.2/274a0413-60d5-4ccb-9a59-2377784a6b42`} target="_self" onClick={closeModal} >
        <p>9.5.3.2	Project Management Plan Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_5.3.3/a8396dad-eb27-4e02-9bf3-7a96ffc98eaa`} target="_self" onClick={closeModal} >
        <p>9.5.3.3	Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_5.3.4/7f1266f0-48d5-464c-95a8-28029b9a4e45`} target="_self" onClick={closeModal} >
        <p>9.5.3.4	Enterprise Environmental Factors Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_1_9_6/c0156152-f958-445e-bd0d-f012a8ec3c33`} target="_self" onClick={closeModal} >
        <p>9.6 Control Resources</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>9.6.1 Control Resources: Inputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_6.1.1/9a81558b-2516-465f-a319-411ea9d6a6fe`} target="_self" onClick={closeModal} >
        <p>9.6.1.1	Project Management Plan</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_6.1.2/04aaacf4-1cb8-46ac-915d-b68a27ddc562`} target="_self" onClick={closeModal} >
        <p>9.6.1.2	Project Documents</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_6.1.3/a42f8bfa-31ac-4cc8-aa78-166f5e58686b`} target="_self" onClick={closeModal} >
        <p>9.6.1.3	Work Performance Data</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_6.1.4/9887fd54-aad2-448c-a151-e49d88581aa3`} target="_self" onClick={closeModal} >
        <p>9.6.1.4	Agreements</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_6.1.5/ce6c4b3a-502b-4d69-a8d7-14b8d9357e13`} target="_self" onClick={closeModal} >
        <p>9.6.1.5	Organizational Process Assets</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>9.6.2 Control Resources: Tools and Techniques</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_6.2.1/76950b33-5269-418b-98cd-88f2a2936d13`} target="_self" onClick={closeModal} >
        <p>9.6.2.1	Data Analysis</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_6.2.2/414e8921-a858-4e8a-afb4-b0bfccd9bd48`} target="_self" onClick={closeModal} >
        <p>9.6.2.2	Problem Solving</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_6.2.3/f757e7e1-df8a-49ea-a7d6-acaa08a28913`} target="_self" onClick={closeModal} >
        <p>9.6.2.3	Interpersonal And Team Skills</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_6.2.4/d1c7bbd7-403c-487e-95af-db620520182a`} target="_self" onClick={closeModal} >
        <p>9.6.2.4	Project Management Information System (Pmis)</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>9.6.3 Control Resources: Outputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_6.3.1/9b98f1f4-5992-4f46-9d6b-05ff1152837e`} target="_self" onClick={closeModal} >
        <p>9.6.3.1	Work Performance Information</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_6.3.2/ad797b19-59af-4b32-80e0-016eede0ef2d`} target="_self" onClick={closeModal} >
        <p>9.6.3.2	Change Requests</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_6.3.3/2c37ca70-f663-4cfa-b3c2-89ed4d4ec9a7`} target="_self" onClick={closeModal} >
        <p>9.6.3.3	Project Management Plan Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_9_6.3.4/6d0cf461-2789-4e79-b8eb-329defbe1301`} target="_self" onClick={closeModal} >
        <p>9.6.3.4	Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-a' to={`/posts/pmbok6_1_10_0/5cbd75e9-d194-4709-8331-5454e4104de8`} target="_self" onClick={closeModal} >
        <p>10 Project Communications Management</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_1_10_1/ad009831-8f93-44c9-9b6d-d7b0a6e52a61`} target="_self" onClick={closeModal} >
        <p>10.1 Plan Communications Management</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>10.1.1 Plan Communications Management: Inputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_10_1.1.1/eee3ff0d-225c-4180-b502-8737edd262ba`} target="_self" onClick={closeModal} >
        <p>10.1.1.1	Project Charter</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_10_1.1.2/69c5c5ad-2e72-421b-8561-afc3d7818c21`} target="_self" onClick={closeModal} >
        <p>10.1.1.2	Project Management Plan</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_10_1.1.3/59ff8f04-4403-4781-9bd5-a06c0bb854ce`} target="_self" onClick={closeModal} >
        <p>10.1.1.3	Project Documents</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_10_1.1.4/44226cd8-52e0-473c-9104-4a1ca7df81b6`} target="_self" onClick={closeModal} >
        <p>10.1.1.4	Enterprise Environmental Factors</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_10_1.1.5/8bbc4db9-7065-410b-bb79-d63c8ef5602f`} target="_self" onClick={closeModal} >
        <p>10.1.1.5	Organizational Process Assets</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>10.1.2 Plan Communications Management Tools and Techniques</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_10_1.2.1/9b1830fe-edbe-4e8f-b9e7-e97f255e87b2`} target="_self" onClick={closeModal} >
        <p>10.1.2.1	Expert Judgement</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_10_1.2.2/cf391a29-dccd-48aa-8ac9-fc334d08dc15`} target="_self" onClick={closeModal} >
        <p>10.1.2.2	Communication Requirements Analysis</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_10_1.2.3/c8662183-5663-46fb-ac77-6c115f6af9ef`} target="_self" onClick={closeModal} >
        <p>10.1.2.3	Communication Technology</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_10_1.2.4/8bb56f79-5873-4b4f-959e-29202b68c755`} target="_self" onClick={closeModal} >
        <p>10.1.2.4	Communication Models</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_10_1.2.5/7ad8c777-f4a8-486e-aa5a-82c4fb2cb703`} target="_self" onClick={closeModal} >
        <p>10.1.2.5	Communication Methods</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_10_1.2.6/57b8d01c-469b-41af-a6f2-83d01c92f448`} target="_self" onClick={closeModal} >
        <p>10.1.2.6	Interpersonal And Team Skills</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_10_1.2.7/067ab300-b07c-4cef-a278-f507ff81a399`} target="_self" onClick={closeModal} >
        <p>10.1.2.7	Data Representation</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_10_1.2.8/6598d3a3-92ab-41a1-bc13-8aae37f05878`} target="_self" onClick={closeModal} >
        <p>10.1.2.8	Meetings</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>10.1.3 Plan Communications Management: Outputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_10_1.3.1/39c1b7c9-a024-4ef5-8373-580a687af43f`} target="_self" onClick={closeModal} >
        <p>10.1.3.1	Communication Management Plan</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_10_1.3.2/2864ac68-6e33-48aa-81a9-ef99aa44f463`} target="_self" onClick={closeModal} >
        <p>10.1.3.2	Project Management Plan Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_10_1.3.3/a412b2d9-c1dd-4170-836c-4103a224b245`} target="_self" onClick={closeModal} >
        <p>10.1.3.3	Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_1_10_2/e70194b3-6173-41e3-bce8-ce3078a3ec47`} target="_self" onClick={closeModal} >
        <p>10.2 Manage Communications</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>10.2.1 Manage Communications: Inputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_10_2.1.1/cd2b016d-251d-4342-861c-48007f27c917`} target="_self" onClick={closeModal} >
        <p>10.2.1.1	Project Management Plan</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_10_2.1.2/6f80cccd-6791-430c-80b5-6393b6db02f0`} target="_self" onClick={closeModal} >
        <p>10.2.1.2	Project Documents</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_10_2.1.3/6dc99b9b-5bd5-47ea-82f4-10fe5d365f83`} target="_self" onClick={closeModal} >
        <p>10.2.1.3	Work Performance Report</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_10_2.1.4/d1e31b36-0382-4779-8d2e-eefa46a91d38`} target="_self" onClick={closeModal} >
        <p>10.2.1.4	Enterprise Environmental Factor</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_10_2.1.5/113dd87e-09a1-4614-82ae-f806a77c175e`} target="_self" onClick={closeModal} >
        <p>10.2.1.5	Organizational Process Assets</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>10.2.2 Manage Communications: Tools and Techniques</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_10_2.2.1/d1173006-4ab1-45c5-a519-a1ef1894f8be`} target="_self" onClick={closeModal} >
        <p>10.2.2.1	Communication Technology</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_10_2.2.2/70c853a8-41e1-4666-9a94-6798a77ad6a0`} target="_self" onClick={closeModal} >
        <p>10.2.2.2	Communication Methods</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_10_2.2.3/536c9a78-ee19-465c-9f1f-c012fbf86c9d`} target="_self" onClick={closeModal} >
        <p>10.2.2.3	Communication Skills</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_10_2.2.4/2172ac07-1897-4ee5-a31d-bed4c875967d`} target="_self" onClick={closeModal} >
        <p>10.2.2.4	Project Management Information Systems (Pmis)</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_10_2.2.5/3fd638e4-f8cf-4dc7-ae14-54d12ee5c5bf`} target="_self" onClick={closeModal} >
        <p>10.2.2.5	Project Reporting</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_10_2.2.6/d77771ee-4f7f-4a31-927c-d42961e43263`} target="_self" onClick={closeModal} >
        <p>10.2.2.6	Interpersonal And Team Skills</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_10_2.2.7/a55955d0-84f0-4612-8070-f1f66412ea4d`} target="_self" onClick={closeModal} >
        <p>10.2.2.7	Meetings</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>10.2.3 Manage Communications: Outputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_10_2.3.1/0c135ab5-3727-41ba-b9f7-0b6a174fdbce`} target="_self" onClick={closeModal} >
        <p>10.2.3.1	Project Communications</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_10_2.3.2/093600b3-ec71-4a01-8054-66347e2c280c`} target="_self" onClick={closeModal} >
        <p>10.2.3.2	Project Management Plan Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_10_2.3.3/1bbb33a8-28d1-4617-9e9d-67eca98b7a39`} target="_self" onClick={closeModal} >
        <p>10.2.3.3	Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_10_2.3.4/8910574c-4f22-4461-8322-5f7fed107fbb`} target="_self" onClick={closeModal} >
        <p>10.2.3.4	Organizational Process Assets Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>10.3 Monitor Communications</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>10.3.1 Monitor Communications: Inputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_10_3.1.1/632aeb0a-efc8-4d74-beab-d3cb460bf9bc`} target="_self" onClick={closeModal} >
        <p>10.3.1.1	Project Management Plan</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_10_3.1.2/9258fb6f-7dab-4d26-926c-324a7ef26dbe`} target="_self" onClick={closeModal} >
        <p>10.3.1.2	Project Documents</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_10_3.1.3/414775ee-7813-42a7-8e25-c3ed3f6d4a50`} target="_self" onClick={closeModal} >
        <p>10.3.1.3	Work Performance Data</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_10_3.1.4/58a3290a-825f-470d-b7db-f1b664edf0c4`} target="_self" onClick={closeModal} >
        <p>10.3.1.4	Enterprise Environmental Factors</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_10_3.1.5/32d009d1-6c7b-4d0b-80a2-b23cae4a2a1d`} target="_self" onClick={closeModal} >
        <p>10.3.1.5	Organizational Process Assets</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>10.3.2 Monitor Communications: Tools and Techniques</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_10_3.2.1/ec0b2225-96b4-4243-ac49-479944edc598`} target="_self" onClick={closeModal} >
        <p>10.3.2.1	Expert Judgment</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_10_3.2.2/7d548dc4-b414-4c25-a6d3-a122a21fda70`} target="_self" onClick={closeModal} >
        <p>10.3.2.2	Project Management Information System (PMIS)</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_10_3.2.3/f2712ab4-a8fc-4f03-a95d-8a5947fd8737`} target="_self" onClick={closeModal} >
        <p>10.3.2.3	Data Representation</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_10_3.2.4/726d34b7-ac65-4a66-be49-1d6a27e68834`} target="_self" onClick={closeModal} >
        <p>10.3.2.4	Interpersonal And Team Skills</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_10_3.2.5/ad9f3dc5-0c1a-422e-b2ce-f030c995261a`} target="_self" onClick={closeModal} >
        <p>10.3.2.5	Meetings</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>10.3.3 Monitor Commuications: Outputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_10_3.3.1/cf0503f2-453c-4de6-b98a-36c48ccff3e1`} target="_self" onClick={closeModal} >
        <p>10.3.3.1	Work Performance Information</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_10_3.3.2/0e851332-1f0c-4262-8d10-d58509b6c827`} target="_self" onClick={closeModal} >
        <p>10.3.3.2	Change Requests</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_10_3.3.3/474b3be0-c2a6-4329-ad21-aa4e50dc1d26`} target="_self" onClick={closeModal} >
        <p>10.3.3.3	Project Management Plan Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_10_3.3.4/2fbae605-70a0-4716-a5b2-872f17cfa20d`} target="_self" onClick={closeModal} >
        <p>10.3.3.4	Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-a' to={`/posts/pmbok6_1_11_0/b1dcb9b0-2f76-4392-bd1b-f8e3541ead48`} target="_self" onClick={closeModal} >
        <p>11 Project Risk Management</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_1_11_1/0400b360-04ec-432d-bf06-12bc1e7d1e6b`} target="_self" onClick={closeModal} >
        <p>11.1 Plan Risk Management</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>11.1.1 Plan Risk Management: Inputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_1.1.1/8a6211ca-dbe2-4eb1-b7be-622a198f6400`} target="_self" onClick={closeModal} >
        <p>11.1.1.1	Project Charter</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_1.1.2/9fccfd81-968a-47cf-8504-90a0dd4aa3f0`} target="_self" onClick={closeModal} >
        <p>11.1.1.2	Project Management Plan</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_1.1.3/922b751c-f0a4-4988-a633-b68ccf316f9b`} target="_self" onClick={closeModal} >
        <p>11.1.1.3	Project Documents</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_1.1.4/78478f8d-d592-4255-a56c-4ae476d0803a`} target="_self" onClick={closeModal} >
        <p>11.1.1.4	Enterprise Environmental Factors</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_1.1.5/7081b3e1-a846-4d8f-bb67-d3094ea0912d`} target="_self" onClick={closeModal} >
        <p>11.1.1.5	Organizational Process Assets</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>11.1.2 Plan Risk Management: Tools and Techniques</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_1.2.1/961a428c-6c3b-4a1e-8523-316c505501a2`} target="_self" onClick={closeModal} >
        <p>11.1.2.1	Expert Judgement</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_1.2.2/d7994838-a9a5-4f44-ad38-bdc93a5a7a41`} target="_self" onClick={closeModal} >
        <p>11.1.2.2	Data Analysis</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_1.2.3/36070398-6df0-48a5-a5a6-bf6f0bc1a6b3`} target="_self" onClick={closeModal} >
        <p>11.1.2.3	Meetings</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>11.1.3 Plan Risk Management: Outputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_1.3.1/8cbbc1f5-3ce3-49f7-8d30-9fc0e3b5c54c`} target="_self" onClick={closeModal} >
        <p>11.1.3.1	Risk Management Plan</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_1_11_2/b3e4fcba-ecb8-4208-b4e2-e972a6602f30`} target="_self" onClick={closeModal} >
        <p>11.2 Identify Risks</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>11.2.1 Identify Risks: Inputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_2.1.1/334a7524-fd37-4353-959a-17ead8ad598c`} target="_self" onClick={closeModal} >
        <p>11.2.1.1	Project Management Plan</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_2.1.2/19b68e3e-5100-4117-98dd-a06424fdc1c6`} target="_self" onClick={closeModal} >
        <p>11.2.1.2	Project Documents</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_2.1.3/7d336ef5-ca2b-4f43-86a5-94594b531f99`} target="_self" onClick={closeModal} >
        <p>11.2.1.3	Agreements</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_2.1.4/1e92ec85-f7b7-43b9-89d2-370b8123d6c2`} target="_self" onClick={closeModal} >
        <p>11.2.1.4	Procurement Documentation</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_2.1.5/4628ddf1-3478-4ab7-973d-9583820177f9`} target="_self" onClick={closeModal} >
        <p>11.2.1.5	Enterprise Environmental Factors</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_2.1.6/7feae2c7-76ae-43cf-bd1d-d4f9ee039765`} target="_self" onClick={closeModal} >
        <p>11.2.1.6	Organizational Process Assets</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>11.2.2 Identify Risks: Tools and Techniques</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_2.2.1/58df47b0-2c4a-4795-82a9-87283df32aaa`} target="_self" onClick={closeModal} >
        <p>11.2.2.1	Expert Judgement</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_2.2.2/8f96ecf4-5425-40c9-8fdc-7a9cb17d8eab`} target="_self" onClick={closeModal} >
        <p>11.2.2.2	Data Gathering</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_2.2.3/d3746458-160e-4c22-8cc0-f02b9af5f620`} target="_self" onClick={closeModal} >
        <p>11.2.2.3	Data Analysis</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_2.2.4/b608544c-456d-4980-8e05-6c07cff03508`} target="_self" onClick={closeModal} >
        <p>11.2.2.4	Interpersonal And Team Skills</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_2.2.5/066b92e1-c310-4486-8b14-49a3f3bfcd01`} target="_self" onClick={closeModal} >
        <p>11.2.2.5	Prompt Lists</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_2.2.6/0a98abdd-32df-4402-a74c-58ae269c0a00`} target="_self" onClick={closeModal} >
        <p>11.2.2.6	Meetings</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>11.2.3 Identify Risks: Outputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_2.3.1/3edca5a1-d6cb-458c-a277-e29c791d02e5`} target="_self" onClick={closeModal} >
        <p>11.2.3.1	Risk Register</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_2.3.2/5ca5481c-15a2-4131-a437-e4edfaa88564`} target="_self" onClick={closeModal} >
        <p>11.2.3.2	Risk Report</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_2.3.3/58fa34b9-5dc0-405a-9223-381edc276669`} target="_self" onClick={closeModal} >
        <p>11.2.3.3	Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_1_11_3/1f3dcb40-9386-46a1-adc2-cac398fcd8ab`} target="_self" onClick={closeModal} >
        <p>11.3 Perform Qualitative Risk Analysis</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>11.3.1 Perform Qualitative Risk Analysis: Inputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_3.1.1/88ed4d7d-4e46-4d00-8105-0267a85916bc`} target="_self" onClick={closeModal} >
        <p>11.3.1.1	Project Management Plan</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_3.1.2/908d3fe0-1899-41c7-b51d-49ede1a14fdb`} target="_self" onClick={closeModal} >
        <p>11.3.1.2	Project Documents</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_3.1.3/04a75ee3-995d-4685-8ecf-6728e3a7b5e1`} target="_self" onClick={closeModal} >
        <p>11.3.1.3	Enterprise Environmental Factors</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_3.1.4/fd49c3bd-b636-4295-b680-7669f97ecf7a`} target="_self" onClick={closeModal} >
        <p>11.3.1.4	Organizational Process Assets</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>11.3.2 Peform Qualitative Risk Analysis: Tools and Techniques</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_3.2.1/d3f67915-0e44-4df5-bc7b-3f47b87c1165`} target="_self" onClick={closeModal} >
        <p>11.3.2.1	Expert Judgement</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_3.2.2/a525f7d5-1ca4-45f5-8d33-217ee81847ba`} target="_self" onClick={closeModal} >
        <p>11.3.2.2	Data Gathering</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_3.2.3/2cac3607-e144-4308-9a69-db9d5e286e0a`} target="_self" onClick={closeModal} >
        <p>11.3.2.3	Data Analysis</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_3.2.4/732bd80c-0c36-4b3f-a7bd-d565ac8f3d76`} target="_self" onClick={closeModal} >
        <p>11.3.2.4	Interpersonal And Team Skills</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_3.2.5/956403c1-67b6-4f5f-98e6-31396a727d52`} target="_self" onClick={closeModal} >
        <p>11.3.2.5	Risk Categorization</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_3.2.6/c434ecdf-d8e3-4317-82b7-76ace5e67078`} target="_self" onClick={closeModal} >
        <p>11.3.2.6	Data Representation</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_3.2.7/7d5b019e-0cf4-4876-a3cc-1dc9c7e2ae1d`} target="_self" onClick={closeModal} >
        <p>11.3.2.7	Meetings</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>11.3.3 Perform Qualitative Risk Analysis: Outputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_3.3.1/d74f8f23-eadb-4469-954b-fbee3170fcde`} target="_self" onClick={closeModal} >
        <p>11.3.3.1	Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_1_11_4/2280afdb-96c9-41cd-b999-c7d1334db164`} target="_self" onClick={closeModal} >
        <p>11.4 Perform Quantitative Risk Analysis</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>11.4.1 Perform Quantitative Risk Analysis: Inputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_4.1.1/b82bda41-cada-4a81-b63f-063d1947e931`} target="_self" onClick={closeModal} >
        <p>11.4.1.1	Project Management Plan</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_4.1.2/2c118ace-e6c7-4a96-ac33-c5af32f60e99`} target="_self" onClick={closeModal} >
        <p>11.4.1.2	Project Documents</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_4.1.3/850db0b1-3430-4637-b707-91ec2ed2342e`} target="_self" onClick={closeModal} >
        <p>11.4.1.3	Enterprise Environmental Factors</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_4.1.4/6754c4e8-4dea-43ca-b88c-215e65310ed8`} target="_self" onClick={closeModal} >
        <p>11.4.1.4	Organizational Process Assets</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>11.4.2 Perform Quantitative Risk Analysis: Tools and Techniques</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_4.2.1/19843836-a6da-42f1-beb2-23228c77c4ee`} target="_self" onClick={closeModal} >
        <p>11.4.2.1	Expert Judgement</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_4.2.2/7d11dbf7-7963-4007-986f-9b8fa8b4b841`} target="_self" onClick={closeModal} >
        <p>11.4.2.2	Data Gathering</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_4.2.3/fce1112e-e174-457d-b647-eeee6cd2f218`} target="_self" onClick={closeModal} >
        <p>11.4.2.3	Interpersonal And Team Skills</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_4.2.4/54560849-e8df-4fe5-b023-84e465d3f7e8`} target="_self" onClick={closeModal} >
        <p>11.4.2.4	Presentations Of Uncertainty</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_4.2.5/bda1d14b-6ffe-463e-9687-ac9da89c9d11`} target="_self" onClick={closeModal} >
        <p>11.4.2.5	Data Analysis</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>11.4.3 Perform Quantitative Risk Analysis: Outputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_4.3.1/6ad20ae8-4755-4399-811b-e3bf19c02e8f`} target="_self" onClick={closeModal} >
        <p>11.4.3.1	Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_1_11_5/901ddbdb-12f8-444c-a9d6-f52ae3974056`} target="_self" onClick={closeModal} >
        <p>11.5 Plan Risk Responses</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>11.5.1 Plan Risk Responses: Inputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_5.1.1/91583d6a-952c-43d6-ac7b-40bf5a4a7f65`} target="_self" onClick={closeModal} >
        <p>11.5.1.1	Project Management Plan</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_5.1.2/49441ef2-91dd-4003-ba2a-f14ee6e53df2`} target="_self" onClick={closeModal} >
        <p>11.5.1.2	Project Documents</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_5.1.3/f7643820-3f87-40f2-bf75-177d7cea5a96`} target="_self" onClick={closeModal} >
        <p>11.5.1.3	Enterprise Environmental Factors</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_5.1.4/b6170a5d-0eff-40f9-9785-484a8598445c`} target="_self" onClick={closeModal} >
        <p>11.5.1.4	Organizational Process Assets</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>11.5.2 Plan Risk Responses: Tools and Techniques</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_5.2.1/26d1de12-8226-4939-83af-74cf9a402f05`} target="_self" onClick={closeModal} >
        <p>11.5.2.1	Expert Judgment</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_5.2.2/6533c29b-8ca8-40da-afd4-c7ccb9854cb0`} target="_self" onClick={closeModal} >
        <p>11.5.2.2	Data Gathering</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_5.2.3/89277e42-628f-4fab-9ba3-497eeb030e81`} target="_self" onClick={closeModal} >
        <p>11.5.2.3	Interpersonal And Team Skills</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_5.2.4/b5ef2cb9-182b-425b-b64e-bcf52199099f`} target="_self" onClick={closeModal} >
        <p>11.5.2.4	Strategies For Threats</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_5.2.5/16773d3f-3faf-414a-a0c1-657215705799`} target="_self" onClick={closeModal} >
        <p>11.5.2.5	Strategies For Opportunities</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_5.2.6/a2d4f300-bbd5-448a-9da4-228a1b37c8b7`} target="_self" onClick={closeModal} >
        <p>11.5.2.6	Contingent Response Strategies</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_5.2.7/4d85bd3c-2723-4935-b512-c207e5a12db6`} target="_self" onClick={closeModal} >
        <p>11.5.2.7	Strategies For Overall Project Risk</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_5.2.8/8a592e61-42f3-4021-aaa8-cfde66f2fa05`} target="_self" onClick={closeModal} >
        <p>11.5.2.8	Data Analysis</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_5.2.9/2b9f381a-0108-4257-926d-281ad10db31c`} target="_self" onClick={closeModal} >
        <p>11.5.2.9	Decision Making</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>11.5.3 Plan Risk Responses: Outputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_5.3.1/ce8e2f81-ed92-4699-8b9a-3ac2a4b51212`} target="_self" onClick={closeModal} >
        <p>11.5.3.1	Change Requests</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_5.3.2/f7f5defe-b28c-4af4-bf33-60d3955d81b6`} target="_self" onClick={closeModal} >
        <p>11.5.3.2	Project Management Plan Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_5.3.3/73253bda-96d2-4e9b-8d5d-2fa9f2d61efa`} target="_self" onClick={closeModal} >
        <p>11.5.3.3	Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_1_11_6/5eda23d2-4c89-41cf-88ba-f3b4337a41d9`} target="_self" onClick={closeModal} >
        <p>11.6 Implement Risk Responses</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>11.6.1 Implement Risk Responses: Inputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_6.1.1/7ce3fe49-7e83-4354-bae0-b14d47a2095f`} target="_self" onClick={closeModal} >
        <p>11.6.1.1	Project Management Plan</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_6.1.2/8cd6b733-6501-4622-b226-edf3a6104ac7`} target="_self" onClick={closeModal} >
        <p>11.6.1.2	Project Documents</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_6.1.3/43d5bddf-1dfb-4f5f-b4f3-222f7995e971`} target="_self" onClick={closeModal} >
        <p>11.6.1.3	Organizational Process Assets</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>11.6.2 Implement Risk Responses: Tools and Techniques</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_6.2.1/a9f805ff-302e-46ae-bdd2-c52c739a8ab0`} target="_self" onClick={closeModal} >
        <p>11.6.2.1	Expert Judgment</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_6.2.2/2855f413-6684-4886-8b45-e197a9452b4a`} target="_self" onClick={closeModal} >
        <p>11.6.2.2	Interpersonal And Team Skills</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_6.2.3/9797dd2f-1253-415c-b596-b12ce87d8567`} target="_self" onClick={closeModal} >
        <p>11.6.2.3	Project Management Information System (Pmis)</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>11.6.3 Implement Risk Responses: Outputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_6.3.1/d3c73e90-0c65-4a29-92da-f292b74b11f9`} target="_self" onClick={closeModal} >
        <p>11.6.3.1	Change Requests</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_6.3.2/5548ce32-0935-4c81-bd8e-490dc8068ebb`} target="_self" onClick={closeModal} >
        <p>11.6.3.2	Project Document Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_1_11_7/78bd2197-be16-409f-9d66-65ccda516ae8`} target="_self" onClick={closeModal} >
        <p>11.7 Monitor Risks</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>11.7.1 Monitor Risks: Inputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_7.1.1/39c4c931-a644-46d4-a4af-ee784528a448`} target="_self" onClick={closeModal} >
        <p>11.7.1.1	Project Management Plan</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_7.1.2/ff5e31d4-1f84-408e-8928-067851bff69b`} target="_self" onClick={closeModal} >
        <p>11.7.1.2	Project Documents</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_7.1.3/b135c9b4-d53b-43b9-a432-bea2d6442290`} target="_self" onClick={closeModal} >
        <p>11.7.1.3	Work Performance Data</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_7.1.4/0c2bb5e2-97d8-4d49-b17f-7f66b50388fb`} target="_self" onClick={closeModal} >
        <p>11.7.1.4	Work Performance Reports</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>11.7.2 Monitor Risks: Tools and Techniques</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_7.2.1/f6607941-79d5-45ad-9a55-09d5b61ca0bf`} target="_self" onClick={closeModal} >
        <p>11.7.2.1	Data Analysis</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_7.2.2/5348ffa4-36d8-41d4-add2-18500e4023ab`} target="_self" onClick={closeModal} >
        <p>11.7.2.2	Audits</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_7.2.3/08e07404-ac12-4950-a6aa-b126e83120c0`} target="_self" onClick={closeModal} >
        <p>11.7.2.3	Meetings</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>11.7.3 Monitor Risks: Outputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_7.3.1/e811dbbe-9fbf-425c-b194-9750d07a6f78`} target="_self" onClick={closeModal} >
        <p>11.7.3.1	Work Performance Information</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_7.3.2/80fbd6dc-21b8-4e0f-b69b-d468a44c6129`} target="_self" onClick={closeModal} >
        <p>11.7.3.2	Change Requests</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_7.3.3/ef762d4c-c855-4ad5-b93f-1e4f7b021f80`} target="_self" onClick={closeModal} >
        <p>11.7.3.3	Project Management Plan Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_7.3.4/ef01380e-2c66-4a84-bcf0-4583b2c332dc`} target="_self" onClick={closeModal} >
        <p>11.7.3.4	Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_11_7.3.5/eca4b9c8-2b58-43d6-acfb-437b338c3dab`} target="_self" onClick={closeModal} >
        <p>11.7.3.5	Organizational Process Assets And Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-a' to={`/posts/pmbok6_1_12_0/52c6cfa3-7b73-4c7a-88de-56a229e23ff0`} target="_self" onClick={closeModal} >
        <p>12 Project Procurement Management</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_1_12_1/79d7c8e3-b3e5-48df-8510-a287393872d4`} target="_self" onClick={closeModal} >
        <p>12.1 Plan Procurement Management</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>12.1.1 Plan Procurement Management: Inputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_12_1.1.1/8ffe9e6b-eeb1-4c5b-a8a3-d8c4c31adab6`} target="_self" onClick={closeModal} >
        <p>12.1.1.1	Project Charter</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_12_1.1.2/9bd967f1-331d-4067-8e67-3fa8c032f283`} target="_self" onClick={closeModal} >
        <p>12.1.1.2	Business Documents</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_12_1.1.3/62a57552-a56f-4273-9983-034e8a834166`} target="_self" onClick={closeModal} >
        <p>12.1.1.3	Project Management Plan</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_12_1.1.4/d2da581c-e166-400b-80d1-39a0a8735504`} target="_self" onClick={closeModal} >
        <p>12.1.1.4	Project Documents</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_12_1.1.5/2a1cd9f3-0468-4a45-a5e1-e570cd7b5e5c`} target="_self" onClick={closeModal} >
        <p>12.1.1.5	Enterprise Environmental Factors</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_12_1.1.6/e0eb9fd2-c305-4879-823f-eeb21555acf3`} target="_self" onClick={closeModal} >
        <p>12.1.1.6	Organizational Process Assets</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>12.1.2 Plan Procurement Management: Tools and Techniques</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_12_1.2.1/8426b969-4169-4aea-b866-3cfc7716efb7`} target="_self" onClick={closeModal} >
        <p>12.1.2.1	Expert Judgment</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_12_1.2.2/f54265c3-9f6e-4b28-b381-d62299b04957`} target="_self" onClick={closeModal} >
        <p>12.1.2.2	Data Gathering</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_12_1.2.3/3695ede4-61b9-4c61-b5bb-8093cab22a59`} target="_self" onClick={closeModal} >
        <p>12.1.2.3	Data Analysis</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_12_1.2.4/24a7e314-6d36-4b8d-8a0b-4dd1ffd4d15e`} target="_self" onClick={closeModal} >
        <p>12.1.2.4	Source Selection Analysis</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_12_1.2.5/eecabbf6-2d9e-4c0b-9500-d8b3b7d5d6b5`} target="_self" onClick={closeModal} >
        <p>12.1.2.5	Meetings</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>12.1.3 Plan Procurement Management: Outputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_12_1.3.1/c3070251-716a-4cf0-814f-c75e399e4bdf`} target="_self" onClick={closeModal} >
        <p>12.1.3.1	Procurement Management Plan</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_12_1.3.2/d5671366-539c-4c3c-8869-e0f48672dd44`} target="_self" onClick={closeModal} >
        <p>12.1.3.2	Procurement Strategy</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_12_1.3.3/cf36bb2e-893c-4275-8e93-d63f79e48a90`} target="_self" onClick={closeModal} >
        <p>12.1.3.3	Bid Documents</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_12_1.3.4/b7f2dfc6-1460-431b-b2a9-3d814ac1159f`} target="_self" onClick={closeModal} >
        <p>12.1.3.4	Procurement Statement Of Work</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_12_1.3.5/46c87d42-0be9-479b-88ce-2844f040f401`} target="_self" onClick={closeModal} >
        <p>12.1.3.5	Source Selection Criteria</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_12_1.3.6/9b9ce3a1-f90f-4def-b827-52aaa9713d71`} target="_self" onClick={closeModal} >
        <p>12.1.3.6	Make-Or-Buy Decisions</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_12_1.3.7/233178a4-3328-413c-8fa5-07acec22a56b`} target="_self" onClick={closeModal} >
        <p>12.1.3.7	Independent Cost Estimates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_12_1.3.8/60d77122-29e3-4d0e-b98d-416efcadeb4a`} target="_self" onClick={closeModal} >
        <p>12.1.3.8	Change Requests</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_12_1.3.9/245fc2ac-a770-4608-bfa5-284ae20838ad`} target="_self" onClick={closeModal} >
        <p>12.1.3.9	Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_12_1.3.10/f695986d-9523-412a-badd-f2a38c6d4750`} target="_self" onClick={closeModal} >
        <p>12.1.3.10	Organizational Process Assets Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_1_12_2/b9af0272-c41a-4573-a00c-2223d52d8eda`} target="_self" onClick={closeModal} >
        <p>12.2 Conduct Procurements</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>12.2.1 Conduct Procurements: Inputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_12_2.1.1/57412a6b-97be-40f4-b5ae-4175d092dac7`} target="_self" onClick={closeModal} >
        <p>12.2.1.1	Project Management Plan</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_12_2.1.2/ae98611e-8aa3-4801-9293-6164d96244ef`} target="_self" onClick={closeModal} >
        <p>12.2.1.2	Project Documents</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_12_2.1.3/eec579fe-157c-45cd-b2a9-a94f8ef34da9`} target="_self" onClick={closeModal} >
        <p>12.2.1.3	Procurement Documentation</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_12_2.1.4/2198b466-3c32-4e7d-a4ad-c3e9582da76c`} target="_self" onClick={closeModal} >
        <p>12.2.1.4	Seller Proposals</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_12_2.1.5/dc1ebdef-8599-4ce8-b046-0b0e631cb62a`} target="_self" onClick={closeModal} >
        <p>12.2.1.5	Enterprise Environmental Factors</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_12_2.1.6/d30dabc9-6317-4b37-988c-66889eef4527`} target="_self" onClick={closeModal} >
        <p>12.2.1.6	Organizational Process Assets</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>12.2.2 Conduct Procurements: Tools and Techniques</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_12_2.2.1/8b0015b7-0279-4c6f-b01b-631d71e5c8ca`} target="_self" onClick={closeModal} >
        <p>12.2.2.1	Expert Judgment</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_12_2.2.2/6a63a517-122a-4bc4-b9ab-7bfccec7a685`} target="_self" onClick={closeModal} >
        <p>12.2.2.2	Advertising</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_12_2.2.3/5f39b50f-d282-4255-aca8-629c84ab415e`} target="_self" onClick={closeModal} >
        <p>12.2.2.3	Bidder Conferences</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_12_2.2.4/a8859e83-1dc2-4848-aaad-7fe77131bbde`} target="_self" onClick={closeModal} >
        <p>12.2.2.4	Data Analysis</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_12_2.2.5/33737a3c-0e53-4077-9fe3-a15495c626e6`} target="_self" onClick={closeModal} >
        <p>12.2.2.5	Interpersonal And Team Skills</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>12.2.3 Conduct Procurements: Outputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_12_2.3.1/215a6fe3-e2cd-47d8-a484-5568a7a747d5`} target="_self" onClick={closeModal} >
        <p>12.2.3.1	Selected Sellers</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_12_2.3.2/73ef3d3d-51d3-4f4c-aaec-b4badde8c9fb`} target="_self" onClick={closeModal} >
        <p>12.2.3.2	Agreements</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_12_2.3.3/43d869d4-4a16-4bf4-b71b-033bc2ad77d1`} target="_self" onClick={closeModal} >
        <p>12.2.3.3	Change Requests</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_12_2.3.4/fb9a22ec-7bfa-43f9-8084-9f0d1bdec907`} target="_self" onClick={closeModal} >
        <p>12.2.3.4	Project Management Plan Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_12_2.3.5/c6555f19-1591-494c-b72d-0ed2ee4449a6`} target="_self" onClick={closeModal} >
        <p>12.2.3.5	Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_12_2.3.6/789a9fe2-ea9f-412f-a7f8-3697fc1cc869`} target="_self" onClick={closeModal} >
        <p>12.2.3.6	Organizational Process Assets Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_1_12_3/40c21806-5a6d-498d-bde9-9bd62cb0595e`} target="_self" onClick={closeModal} >
        <p>12.3 Control Procurements</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>12.3.1 Control Procurements: Inputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_12_3.1.1/ca975fee-63ab-4727-9902-2d5cf7967a26`} target="_self" onClick={closeModal} >
        <p>12.3.1.1	Project Management Plan</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_12_3.1.2/27a521f9-b68b-4dfb-9ed6-b6a72867fa69`} target="_self" onClick={closeModal} >
        <p>12.3.1.2	Project Documents</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_12_3.1.3/9a2966a5-7180-4040-950d-d7c64e3ed9d8`} target="_self" onClick={closeModal} >
        <p>12.3.1.3	Agreements</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_12_3.1.4/35c51820-e8b4-420d-8774-84b0ceb32c87`} target="_self" onClick={closeModal} >
        <p>12.3.1.4	Procurement Documentation</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_12_3.1.5/ecd0f032-9517-4592-a24e-827e4eb33246`} target="_self" onClick={closeModal} >
        <p>12.3.1.5	Approved Change Requests</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_12_3.1.6/e5304b6d-d26c-4069-94bd-d311ed355e08`} target="_self" onClick={closeModal} >
        <p>12.3.1.6	Work Performance Data</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_12_3.1.7/dceac7e1-cca2-4d5f-be02-08a0cb7c85f2`} target="_self" onClick={closeModal} >
        <p>12.3.1.7	Enterprise Environmental Factors</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_12_3.1.8/c2890532-1b8b-4bde-8bb2-510a86d3f74b`} target="_self" onClick={closeModal} >
        <p>12.3.1.8	Organizational Process Assets</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>12.3.2 Control Procurements: Tools and Techniques</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_12_3.2.1/1c7a44b0-87b2-40a6-85a5-c928d5efd7dc`} target="_self" onClick={closeModal} >
        <p>12.3.2.1	Expert Judgment</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_12_3.2.2/2972b530-22a9-4438-ada5-78a6dd2b4d69`} target="_self" onClick={closeModal} >
        <p>12.3.2.2	Claims Administration</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_12_3.2.3/ebd36c66-29f1-445f-a846-26ea500acc85`} target="_self" onClick={closeModal} >
        <p>12.3.2.3	Data Analysis</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_12_3.2.4/eb92e235-0f96-4129-a06e-f80b089c51cc`} target="_self" onClick={closeModal} >
        <p>12.3.2.4	Inspection</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_12_3.2.5/84e417e1-2150-4ce9-8492-12bffb9a4ae8`} target="_self" onClick={closeModal} >
        <p>12.3.2.5	Audits</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>12.3.3 Control Procurements: Outputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_12_3.3.1/d8c86e30-1fb4-44fb-a2d5-43ef0939d3f5`} target="_self" onClick={closeModal} >
        <p>12.3.3.1	Closed Procurements</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_12_3.3.2/64e46155-05ac-4d06-9ac2-506999564582`} target="_self" onClick={closeModal} >
        <p>12.3.3.2	Work Performance Information</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_12_3.3.3/5bd4c3d1-fbc2-4b3f-99ab-207de5fef4f9`} target="_self" onClick={closeModal} >
        <p>12.3.3.3	Procurement Documentation Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_12_3.3.4/3149f280-bebb-4ca1-a48c-370128fc3857`} target="_self" onClick={closeModal} >
        <p>12.3.3.4	Change Requests</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_12_3.3.5/ef139815-2ff7-4f42-a83c-974217aec83e`} target="_self" onClick={closeModal} >
        <p>12.3.3.5	Project Management Plan Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_12_3.3.6/a3c0e568-95c0-4763-ab58-fe1d0d221368`} target="_self" onClick={closeModal} >
        <p>12.3.3.6	Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_12_3.3.7/ae1fa843-aeca-4fb8-900c-4bc1b8215cb8`} target="_self" onClick={closeModal} >
        <p>12.3.3.7	Organizational Process Assets Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-a' to={`/posts/pmbok6_1_13_0/baede3fb-e0ed-406c-ad6a-84304acbf31b`} target="_self" onClick={closeModal} >
        <p>13 Project Stakeholder Management</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_1_13_1/5a722f8d-c51e-4168-8bee-f37db9551775`} target="_self" onClick={closeModal} >
        <p>13.1 Identify Stakeholders</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>13.1.1 Identify Stakeholders: Inputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_13_1.1.1/592bc502-a7e5-4c6b-9fb6-bb963aef172a`} target="_self" onClick={closeModal} >
        <p>13.1.1.1	Project Charter</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_13_1.1.2/799dd952-9e67-44e6-a49e-4ffaed9374cc`} target="_self" onClick={closeModal} >
        <p>13.1.1.2	Business Documents</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_13_1.1.3/159b73a3-a6e0-4f0e-8f23-5c02159258f2`} target="_self" onClick={closeModal} >
        <p>13.1.1.3	Project Management Plan</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_13_1.1.4/13a5de8b-ae93-433d-9fbb-f950a18eff47`} target="_self" onClick={closeModal} >
        <p>13.1.1.4	Project Documents</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_13_1.1.5/e7d0868b-eaca-435e-8612-3524e90a7130`} target="_self" onClick={closeModal} >
        <p>13.1.1.5	Agreements</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_13_1.1.6/f3d35f1a-6898-4a33-bb60-6a32c51cdebf`} target="_self" onClick={closeModal} >
        <p>13.1.1.6	Enterprise Environmental Factors</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_13_1.1.7/f714ce64-4b11-457a-a1b7-4f23e53e7855`} target="_self" onClick={closeModal} >
        <p>13.1.1.7	Organizational Process Assets</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>13.1.2 Identify Stakeholders: Tools and Techniques</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_13_1.2.1/27e350ce-c255-4376-b716-0e37e2d071c7`} target="_self" onClick={closeModal} >
        <p>13.1.2.1	Expert Judgment</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_13_1.2.2/f410e7e3-a446-4f00-b959-83992882fa27`} target="_self" onClick={closeModal} >
        <p>13.1.2.2	Data Gathering</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_13_1.2.3/7a666a79-c973-4bef-abf8-0a99c794b609`} target="_self" onClick={closeModal} >
        <p>13.1.2.3	Data Analysis</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_13_1.2.4/4b284243-da43-4950-816f-62fda700fdb9`} target="_self" onClick={closeModal} >
        <p>13.1.2.4	Data Representation</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_13_1.2.5/c8517b7b-05aa-478e-986a-c2a626a0279b`} target="_self" onClick={closeModal} >
        <p>13.1.2.5	Meetings</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>13.1.3 Identiy Stakeholders: Outputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_13_1.3.1/05e96477-b6ac-471b-aeb2-768582dc067b`} target="_self" onClick={closeModal} >
        <p>13.1.3.1	Stakeholder Register</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_13_1.3.2/33139da2-43f8-4eb2-a381-191fafc2a305`} target="_self" onClick={closeModal} >
        <p>13.1.3.2	Change Requests</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_13_1.3.3/4f667275-f0d9-45c8-857e-1726891af749`} target="_self" onClick={closeModal} >
        <p>13.1.3.3	Project Management Plan Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_13_1.3.4/597ef7f9-0b88-4132-b2a0-ac57f8eadd59`} target="_self" onClick={closeModal} >
        <p>13.1.3.4	Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_1_13_2/58a06272-c990-4c89-9e13-478c1766bb42`} target="_self" onClick={closeModal} >
        <p>13.2 Plan Stakeholder Engagement</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>13.2.1 Plan Stakeholder Engagement: Inputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_13_2.1.1/3d9989a9-fb0e-4a0d-8010-d401cef02c79`} target="_self" onClick={closeModal} >
        <p>13.2.1.1	Project Charter</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_13_2.1.2/4878c17a-780b-436c-9783-942136b1a5a5`} target="_self" onClick={closeModal} >
        <p>13.2.1.2	Project Management Plan</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_13_2.1.3/d1e88bbc-5d38-4b0c-9909-1f896a11e93e`} target="_self" onClick={closeModal} >
        <p>13.2.1.3	Project Documents</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_13_2.1.4/cede06f5-6338-4661-a5fc-a79806e79d3c`} target="_self" onClick={closeModal} >
        <p>13.2.1.4	Agreements</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_13_2.1.5/df23d8f6-95ef-4519-ab4c-79d75e26d094`} target="_self" onClick={closeModal} >
        <p>13.2.1.5	Enterprise Environmental Factors</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_13_2.1.6/3cb89c1b-5d7f-469d-b765-a3d313ce5409`} target="_self" onClick={closeModal} >
        <p>13.2.1.6	Organizational Process Assets</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>13.2.2 Plan Stakeholder Engagement: Tools and Techniques</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_13_2.2.1/82c0ed3e-43fb-4bc3-a712-acd043afa77f`} target="_self" onClick={closeModal} >
        <p>13.2.2.1	Expert Judgment</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_13_2.2.2/4ff0fad2-ea4d-47ce-a82d-263398c28504`} target="_self" onClick={closeModal} >
        <p>13.2.2.2	Data Gathering</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_13_2.2.3/94e8580c-dafb-457b-977b-4435b30e1c88`} target="_self" onClick={closeModal} >
        <p>13.2.2.3	Data Analysis</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_13_2.2.4/4a7ec35f-2b36-4cc9-b497-61e07fc43f2d`} target="_self" onClick={closeModal} >
        <p>13.2.2.4	Decision Making</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_13_2.2.5/3bfe59f0-4e00-47f7-b4fb-2d9704f64e59`} target="_self" onClick={closeModal} >
        <p>13.2.2.5	Data Representation</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_13_2.2.6/08f9cd05-adf4-496f-85fe-a2ef15407ecd`} target="_self" onClick={closeModal} >
        <p>13.2.2.6	Meetings</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>13.2.3 Plan Stakeholder Engagement: Outputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_13_2.3.1/9f4185ff-42b5-4ac6-9959-6fa2d0d87ba4`} target="_self" onClick={closeModal} >
        <p>13.2.3.1	Stakeholder Engagement Plan</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_1_13_3/3f992da5-d381-419a-9603-7ec309fe248a`} target="_self" onClick={closeModal} >
        <p>13.3 Manage Stakeholder Engagement</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>13.3.1 Manage Stakeholder Engagement: Inputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_13_3.1.1/a1b90e94-497a-42bd-bc9f-5cc4a22d6781`} target="_self" onClick={closeModal} >
        <p>13.3.1.1	Project Management Plan</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_13_3.1.2/af1c1c5c-2f66-49b1-b580-7dd593703cfc`} target="_self" onClick={closeModal} >
        <p>13.3.1.2	Project Documents</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_13_3.1.3/fddc203d-27a2-4f5c-8bfc-bceb55ff2bed`} target="_self" onClick={closeModal} >
        <p>13.3.1.3	Enterprise Environmental Factors</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_13_3.1.4/2fde303c-bf75-45b4-ba90-2d9741880be9`} target="_self" onClick={closeModal} >
        <p>13.3.1.4	Organizational Process Assets</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>13.3.2 Manage Stakeholder Engagement: Tools and Techniques</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_13_3.2.1/ae477ee0-5013-45d6-a073-d2ef8700355b`} target="_self" onClick={closeModal} >
        <p>13.3.2.1	Expert Judgment</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_13_3.2.2/34e6bd72-68b3-487c-bb9f-c1d45c792bb5`} target="_self" onClick={closeModal} >
        <p>13.3.2.2	Communication Skills</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_13_3.2.3/d95f60b5-b5f8-4f71-9761-06a87250de7d`} target="_self" onClick={closeModal} >
        <p>13.3.2.3	Interpersonal And Team Skills</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_13_3.2.4/287bcfab-a0b1-4781-918c-0c26ecb623be`} target="_self" onClick={closeModal} >
        <p>13.3.2.4	Ground Rules</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_13_3.2.5/baebffaa-4b6b-49a4-931c-1ffcfe11345c`} target="_self" onClick={closeModal} >
        <p>13.3.2.5	Meetings</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>13.3.3 Manage Stakeholder Engagement Outputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_13_3.3.1/1492e3bb-0688-4329-ad32-25d966e45108`} target="_self" onClick={closeModal} >
        <p>13.3.3.1	Change Requests</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_13_3.3.2/efccd936-3bef-4c50-8fe8-ace6035bbec5`} target="_self" onClick={closeModal} >
        <p>13.3.3.2	Project Management Plan Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_13_3.3.3/b8a4a65c-782f-4cfd-a63a-5f29bc2f9dc1`} target="_self" onClick={closeModal} >
        <p>13.3.3.3	Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_1_13_4/8e46b712-bfb7-4145-9218-59edb086689f`} target="_self" onClick={closeModal} >
        <p>13.4 Monitor Stakeholder Engagement</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>13.4.1 Monitor Stakeholder Engagement: Inputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_13_4.1.1/1bdfa570-5089-4be6-95bb-78cc712d1d41`} target="_self" onClick={closeModal} >
        <p>13.4.1.1	Project Management Plan</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_13_4.1.2/136b1e6a-205d-40eb-8ac1-f44a0ce75b97`} target="_self" onClick={closeModal} >
        <p>13.4.1.2	Project Documents</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_13_4.1.3/ea70b6e8-e1a9-4d76-97a8-b6e5d6a4e014`} target="_self" onClick={closeModal} >
        <p>13.4.1.3	Work Performance Data</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_13_4.1.4/62ade2fd-e862-4a91-92f1-5a1ede950352`} target="_self" onClick={closeModal} >
        <p>13.4.1.4	Enterprise Environmental Factors</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_13_4.1.5/6fa3705b-2ddb-4df8-82aa-2228ff600299`} target="_self" onClick={closeModal} >
        <p>13.4.1.5	Organizational Process Assets</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>13.4.2 Monitor Stakeholder Engagement: Tools and Techniques</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_13_4.2.1/4a1ec4a2-9ef1-4cd2-8b37-c3b946c40231`} target="_self" onClick={closeModal} >
        <p>13.4.2.1	Data Analysis</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_13_4.2.2/57c13793-7881-4abb-92a2-d9d2505245a6`} target="_self" onClick={closeModal} >
        <p>13.4.2.2	Decision Making</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_13_4.2.3/7c1796af-683b-42be-b136-13c95700138a`} target="_self" onClick={closeModal} >
        <p>13.4.2.3	Data Representation</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_13_4.2.4/d81045b6-f44e-427c-82b7-823a4277d9e3`} target="_self" onClick={closeModal} >
        <p>13.4.2.4	Communication Skills</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_13_4.2.5/d02ff1b9-365b-48c5-a3ba-c5fcc970093a`} target="_self" onClick={closeModal} >
        <p>13.4.2.5	Interpersonal And Team Skills</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_13_4.2.6/0a70b363-2b98-4e40-a9da-95443e125766`} target="_self" onClick={closeModal} >
        <p>13.4.2.6	Meetings</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c disabled-link' to={`/posts/`} target="_self" onClick={closeModal} >
        <p>13.4.3 Monitor Stakeholder Engagement: Outputs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_13_4.3.1/9a3edaca-c74e-4ac3-a7a9-238402223dd5`} target="_self" onClick={closeModal} >
        <p>13.4.3.1	Work Performance Information</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_13_4.3.2/1e130b19-8c81-4ffb-a08c-6aec53966383`} target="_self" onClick={closeModal} >
        <p>13.4.3.2	Change Requests</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_13_4.3.3/69e01964-fbe7-49cf-82c5-945097fae769`} target="_self" onClick={closeModal} >
        <p>13.4.3.3	Project Management Plan Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-d' to={`/posts/pmbok6_1_13_4.3.4/034454dd-36cd-4c6f-a0e4-40e146e93b8e`} target="_self" onClick={closeModal} >
        <p>13.4.3.4	Project Documents Updates</p>
      </Link>
      <br />
      <h3 className='resource-section font-bold my-5 font-bold'>THE STANDARD FOR PROJECT MANAGEMENT</h3>

      <Link className='inline-block resource-sub-fragment level-a' to={`/posts/pmbok6_2_1_0/2ba6b56c-760b-4f33-951b-3a958c25eef0`} target="_self" onClick={closeModal} >
        <p>1 Introduction</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_2_1_1/c4ee7587-30af-4858-b587-75b10c501e97`} target="_self" onClick={closeModal} >
        <p>1.1 Projects and Project Management</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_2_1_2/c4fff221-f60f-49a0-af18-90a140a73d6b`} target="_self" onClick={closeModal} >
        <p>1.2 Relationships Among Portfolios, Programs, and Projects</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_2_1_3/79aca744-5a41-44f4-92f2-9557e7e416b6`} target="_self" onClick={closeModal} >
        <p>1.3 Linking Organizational Governance And Project Governance</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_2_1_4/a784591a-7046-41a4-b365-00325d263c35`} target="_self" onClick={closeModal} >
        <p>1.4 Project Success And Benefits Management</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_2_1_5/2e457f9b-bb91-4850-8c45-1595005a0548`} target="_self" onClick={closeModal} >
        <p>1.5 The Project Life Cycle</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_2_1_6/6957e514-ac93-4237-b6e4-e3a3f4af61e4`} target="_self" onClick={closeModal} >
        <p>1.6 Project Stakeholders</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_2_1_7/a029737f-7100-43c1-8d1d-f99e00a68062`} target="_self" onClick={closeModal} >
        <p>1.7 Role of the Project Manager</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_2_1_8/2cdafc04-a457-4d3b-90b5-26b0f0cd6b28`} target="_self" onClick={closeModal} >
        <p>1.8 Project Management Knowledge Areas</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_2_1_9/9bde4647-cb1c-449f-ba41-6f1ff0910d73`} target="_self" onClick={closeModal} >
        <p>1.9 Project Management Process Groups</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_2_1_10/19986752-620e-4e21-bb35-609abc849ec4`} target="_self" onClick={closeModal} >
        <p>1.10 Enterprise Environmental Factors and Organizational Process Assets</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_2_1_11/60618ca6-3cb2-428a-9153-444f1e84eea7`} target="_self" onClick={closeModal} >
        <p>1.11 Tailoring The Project Artifacts</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-a' to={`/posts/pmbok6_2_2_0/09fe7afa-62cd-45c8-bf06-cd903ae978af`} target="_self" onClick={closeModal} >
        <p>2 Initiating Process Group</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_2_2_1/88ac280d-380a-431b-b46f-b34257d2d4b2`} target="_self" onClick={closeModal} >
        <p>2.1 Develop Project Charter</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_2_2_2/92e4dd5d-1822-4aab-ad28-12ccf0d8590b`} target="_self" onClick={closeModal} >
        <p>2.2 Identify Stakeholders</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_2_2.1/f7449912-0bca-404d-9d5c-871358c6925b`} target="_self" onClick={closeModal} >
        <p>2.2.1 Project Management Plan Components</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_2_2.2/fd9afc44-cd8e-4194-ba2b-6c12013a973f`} target="_self" onClick={closeModal} >
        <p>2.2.2 Project Documents Examples</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_2_2.3/faa7ae4e-b1ce-42a0-8c51-6a03bfa2cced`} target="_self" onClick={closeModal} >
        <p>2.2.3 Project Management Plan Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_2_2.4/50fdbb68-0bd6-46eb-8dbe-ce126e24a4a1`} target="_self" onClick={closeModal} >
        <p>2.2.4 Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-a' to={`/posts/pmbok6_2_3_0/7156b861-1118-4917-bea2-908e71e3744f`} target="_self" onClick={closeModal} >
        <p>3 Planning Process Groups</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_2_3_1/22f18abb-51c7-4b4e-8674-ceb51922a47e`} target="_self" onClick={closeModal} >
        <p>3.1 Develop Project Management Plan</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_2_3_2/29018da1-eb07-4e9a-b078-ea01102da5b0`} target="_self" onClick={closeModal} >
        <p>3.2 Plan Scope Management</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_2.1/f53b3b9c-ddf3-4779-8c2b-e97b13ca61d1`} target="_self" onClick={closeModal} >
        <p>3.2.1 Project Management Plan Components</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_2_3_3/c6cd12e6-15e1-484e-9664-c1d0acbab8f3`} target="_self" onClick={closeModal} >
        <p>3.3 Collect Requirements</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_3.1/0fb6dd41-74c0-41f3-b6a3-d5dbf3fa0a01`} target="_self" onClick={closeModal} >
        <p>3.3.1 Project Management Plan Components</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_3.2/d3c856d1-b8e3-4e3c-984b-f0fd1abaef2b`} target="_self" onClick={closeModal} >
        <p>3.3.2 Project Documents Examples</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_2_3_4/6253c763-15be-4598-80e1-96ee5453da74`} target="_self" onClick={closeModal} >
        <p>3.4 Define Scope</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_4.1/cf9d36bd-6d59-4434-b2f8-6fc2fb649a75`} target="_self" onClick={closeModal} >
        <p>3.4.1 Project Management Plan Components</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_4.2/5e86b509-4944-4880-8f5e-6a0a46eb39b1`} target="_self" onClick={closeModal} >
        <p>3.4.2 Project Documents Examples</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_4.3/de92ef4a-2ac0-4157-9ddb-4ee2d657ee93`} target="_self" onClick={closeModal} >
        <p>3.4.3 Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_2_3_5/1ba9a756-51b7-4545-90bd-50e5775c01fb`} target="_self" onClick={closeModal} >
        <p>3.5 Create WBS</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_5.1/f30ca830-785d-4187-8082-5a01a02d9516`} target="_self" onClick={closeModal} >
        <p>3.5.1 Project Management Plan Components</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_5.2/80340df9-3eea-4b97-9b6a-cf9ec49fe694`} target="_self" onClick={closeModal} >
        <p>3.5.2 Project Documents Examples</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_5.3/ff55322a-0a23-40e5-84e1-020260823fbe`} target="_self" onClick={closeModal} >
        <p>3.5.3 Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_2_3_6/737f4ac4-7a70-4a0c-a42e-83f518265ed0`} target="_self" onClick={closeModal} >
        <p>3.6 Plan Schedule Management</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_6.1/d7e62393-a520-4985-88cf-45d221c41f9e`} target="_self" onClick={closeModal} >
        <p>3.6.1 Project Management Plan Components</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_2_3_7/ffc68c76-293d-4a84-be41-69b78f8f3684`} target="_self" onClick={closeModal} >
        <p>3.7 Define Activities</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_7.1/bafafdb8-ee72-4e36-9541-ffc759e16998`} target="_self" onClick={closeModal} >
        <p>3.7.1 Project Management Plan Components</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_7.2/e12bd32e-e4a8-45d9-a0ac-0efa12337cad`} target="_self" onClick={closeModal} >
        <p>3.7.2 Project Management Plan Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_2_3_8/1ecd5016-92f8-499b-a9d0-6b92b716ad51`} target="_self" onClick={closeModal} >
        <p>3.8 Sequence Activities</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_8.1/5dd75796-ac3e-421a-8147-a9eea6c821f4`} target="_self" onClick={closeModal} >
        <p>3.8.1 Project Management Plan Components</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_8.2/1ecd5016-92f8-499b-a9d0-6b92b716ad51`} target="_self" onClick={closeModal} >
        <p>3.8.2 Project Documents Examples</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_8.3/43a0e219-9ddc-49cb-ac25-13d9f28c8737`} target="_self" onClick={closeModal} >
        <p>3.8.3 Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_2_3_9/7fa9abf5-3501-47a2-98aa-71d16c48f4d4`} target="_self" onClick={closeModal} >
        <p>3.9 Estimate Activity Durations</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_9.1/024e2c43-ea67-4ddc-bca8-c47b680f4c65`} target="_self" onClick={closeModal} >
        <p>3.9.1 Project Management Plan Components</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_9.2/e224911a-cdc0-4477-b5a4-0b11b153565b`} target="_self" onClick={closeModal} >
        <p>3.9.2 Project Documents Examples</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_9.3/9a8fc5f2-d067-4053-acb9-274084585df2`} target="_self" onClick={closeModal} >
        <p>3.9.3 Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_2_3_10/17c37269-f27f-44d9-a200-151dff24de63`} target="_self" onClick={closeModal} >
        <p>3.10 Develop Schedule</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_10.1/5e8b7af9-13d9-47f2-bedb-dd680c97a6f4`} target="_self" onClick={closeModal} >
        <p>3.10.1 Project Management Plan Components</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_10.2/1feb2750-1434-4c4e-bbaf-0139cb5a1a57`} target="_self" onClick={closeModal} >
        <p>3.10.2 Project Documents Examples</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_10.3/a9967f4b-a933-419a-9051-3957733bb661`} target="_self" onClick={closeModal} >
        <p>3.10.3 Project Management Plan Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_10.4/2e9756e4-2656-4a0e-a1dc-4c5b72ae610a`} target="_self" onClick={closeModal} >
        <p>3.10.4 Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_2_3_11/cebe76bc-16a4-4a36-8863-70b9ffcc714e`} target="_self" onClick={closeModal} >
        <p>3.11 Plan Cost Management</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_11.1/552f28d7-c730-47e9-a3ae-92d7ec650800`} target="_self" onClick={closeModal} >
        <p>3.11.1 Project Management Plan Components</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_2_3_12/8f37935b-82f6-4cbf-a35b-6cae0c353a05`} target="_self" onClick={closeModal} >
        <p>3.12 Estimate Costs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_12.1/7927621c-8e0d-4260-9b7f-f8307e30632c`} target="_self" onClick={closeModal} >
        <p>3.12.1 Project Management Plan Components</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_12.2/70d06bde-5335-445c-8822-42c4deca878d`} target="_self" onClick={closeModal} >
        <p>3.12.2 Project Documents Examples</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_12.3/2b957a81-0730-4a63-b5b1-050dcb60ab0d`} target="_self" onClick={closeModal} >
        <p>3.12.3 Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_2_3_13/a0b990e2-3721-4019-a6d5-0bd57f3d321a`} target="_self" onClick={closeModal} >
        <p>3.13 Determine Budget</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_13.1/8a9d59c6-4192-4351-9021-56228aebcd1c`} target="_self" onClick={closeModal} >
        <p>3.13.1 Project Management Plan Components</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_13.2/fdd8e972-bb86-495f-9fd9-231d3f138490`} target="_self" onClick={closeModal} >
        <p>3.13.2 Project Documents Examples</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_13.3/12decff8-e77e-46a7-aaf3-e80581ac036c`} target="_self" onClick={closeModal} >
        <p>3.13.3 Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_2_3_14/3476ce71-0373-46c3-ab0d-2570b6cea8dc`} target="_self" onClick={closeModal} >
        <p>3.14 Plan Quality Management</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_14.1/b5b8c26f-9952-44ef-86b9-6b3056de8001`} target="_self" onClick={closeModal} >
        <p>3.14.1 Project Management Plan Components</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_14.2/3a851c6e-7914-4a25-a959-7ff8787fc621`} target="_self" onClick={closeModal} >
        <p>3.14.2 Project Documents Examples</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_14.3/96ac73ea-a4f1-4de4-a9a2-b5654677f902`} target="_self" onClick={closeModal} >
        <p>3.14.3 Project Management Plan Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_14.4/b20d3119-d9d8-41fa-a27a-01fc18beb7b8`} target="_self" onClick={closeModal} >
        <p>3.14.4 Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_2_3_15/2f8afaa3-720e-48bb-a257-a44f0fb301ec`} target="_self" onClick={closeModal} >
        <p>3.15 Plan Resource Management</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_15.1/7f15c984-5492-40bc-9fbd-4b939e07f095`} target="_self" onClick={closeModal} >
        <p>3.15.1 Project Management Plan Components</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_15.2/fb563e31-de1a-4625-b64b-7ca8cdfa6eba`} target="_self" onClick={closeModal} >
        <p>3.15.2 Project Documents Examples</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_15.3/db8105dd-b9a1-4965-bc26-276723145456`} target="_self" onClick={closeModal} >
        <p>3.15.3 Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_2_3_16/5b3479ba-8142-46f2-b8bd-2d8558f7e1de`} target="_self" onClick={closeModal} >
        <p>3.16 Estimate Activity Resources</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_16.1/f2b38ace-2037-4ffd-817e-15e8c0dd3dc3`} target="_self" onClick={closeModal} >
        <p>3.16.1 Project Management Plan Components</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_16.2/36a84236-399b-4f7b-a26a-f30564a28b6e`} target="_self" onClick={closeModal} >
        <p>3.16.2 Project Documents Examples</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_16.3/9428d303-e4fa-4c4c-aed1-80437ef95215`} target="_self" onClick={closeModal} >
        <p>3.16.3 Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_2_3_17/7ef10dc9-f6a3-40d3-bf99-7977b149f7bc`} target="_self" onClick={closeModal} >
        <p>3.17 Plan Communications Management</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_17.1/1a8312f5-4fc6-4eed-aaa4-645f7b863e73`} target="_self" onClick={closeModal} >
        <p>3.17.1 Project Management Plan Components</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_17.2/015bc88d-cf53-4d78-b396-9a8aab405f20`} target="_self" onClick={closeModal} >
        <p>3.17.2 Project Documents Examples</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_17.3/87d73506-4f12-4713-aa31-0bccc24f9698`} target="_self" onClick={closeModal} >
        <p>3.17.3 Project Management Plan Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_17.4/27c57618-49a1-448f-ae78-b2cc4afc9f27`} target="_self" onClick={closeModal} >
        <p>3.17.4 Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_2_3_18/cb5319b2-2b8d-438b-bad0-976ad8ab4221`} target="_self" onClick={closeModal} >
        <p>3.18 Plan Risk Management</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_18.1/ba3d69d7-009c-455f-94ac-ff56db0e924e`} target="_self" onClick={closeModal} >
        <p>3.18.1 Project Management Plan Components</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_18.2/0b422f92-8562-49b0-a336-01f4f45512be`} target="_self" onClick={closeModal} >
        <p>3.18.2 Project Documents Examples</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_2_3_19/7b69b354-3216-4e6a-b209-f095edb4d4f9`} target="_self" onClick={closeModal} >
        <p>3.19 Identify Risks</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_19.1/92835ba0-fc80-4b64-be7c-78651c5ec0c5`} target="_self" onClick={closeModal} >
        <p>3.19.1 Project Management Plan Components</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_19.2/6e0107ed-3f49-4665-ab64-dd9a991d06ea`} target="_self" onClick={closeModal} >
        <p>3.19.2 Project Documents Examples</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_19.3/ca12c1b5-5c26-4a80-bcdb-1841b6d6c14e`} target="_self" onClick={closeModal} >
        <p>3.19.3 Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_2_3_20/0b3b119f-da4a-4f76-afc0-096169c46ff1`} target="_self" onClick={closeModal} >
        <p>3.20 Perform Qualitative Risk Analysis</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_20.1/bbae47a6-e76f-4807-a2a9-192c563cb663`} target="_self" onClick={closeModal} >
        <p>3.20.1 Project Management Plan Components</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_20.2/25943dec-7913-4077-8b1d-645afd596089`} target="_self" onClick={closeModal} >
        <p>3.20.2 Project Documents Examples</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_20.3/e9392c62-7624-4faa-ae7d-0cfd4e471084`} target="_self" onClick={closeModal} >
        <p>3.20.3 Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_2_3_21/706fa257-c5a0-475d-a847-3641b253355a`} target="_self" onClick={closeModal} >
        <p>3.21 Perform Quantitative Risk Analysis</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_21.1/ad01a03a-2fe8-4091-b322-e35f0bcd6ab5`} target="_self" onClick={closeModal} >
        <p>3.21.1 Project Management Plan Components</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_21.2/0a4ecdb6-0a73-4742-ac0d-81616ec87bb7`} target="_self" onClick={closeModal} >
        <p>3.21.2 Project Documents Examples</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_21.3/e43d68a4-b96a-4bd9-96a0-c3bcef116f0c`} target="_self" onClick={closeModal} >
        <p>3.21.3 Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_2_3_22/2ecf07cb-16b9-4f3e-9464-e71a98cb632a`} target="_self" onClick={closeModal} >
        <p>3.22 Plan Risk Responses</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_22.1/c2a23e59-affd-4937-8f3b-99e860395dce`} target="_self" onClick={closeModal} >
        <p>3.22.1 Project Management Plan Components</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_22.2/19dbac68-7c6c-4c49-96fd-513b4816aa12`} target="_self" onClick={closeModal} >
        <p>3.22.2 Project Documents Examples</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_22.3/e052b01c-6a10-4ef0-98a9-ee0bb53ea5b0`} target="_self" onClick={closeModal} >
        <p>3.22.3 Project Management Plan Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_22.4/38c844d9-7c45-423d-8d37-e4faa779c8f7`} target="_self" onClick={closeModal} >
        <p>3.22.4 Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_2_3_23/edfbd935-0c84-48d5-b3f0-2f439ffe598f`} target="_self" onClick={closeModal} >
        <p>3.23 Plan Procurement Management</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_23.1/e6a20657-6048-43e4-b3ff-1c19151fb33e`} target="_self" onClick={closeModal} >
        <p>3.23.1 Project Management Plan Components</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_23.2/1570c225-0531-4a03-b59a-ae10aa1aed0f`} target="_self" onClick={closeModal} >
        <p>3.23.2 Project Documents Examples</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_23.3/06d717d5-7dc5-42f0-80a1-444be9ae2de2`} target="_self" onClick={closeModal} >
        <p>3.23.3 Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_2_3_24/56fccace-18f3-4afc-8b11-cd670c0fe7ca`} target="_self" onClick={closeModal} >
        <p>3.24 Plan Stakeholder Engagement</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_24.1/552c1c60-7ff1-4b80-b951-75a3a0ec39cb`} target="_self" onClick={closeModal} >
        <p>3.24.1 Project Management Plan Components</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_3_24.2/0ba367c9-f32e-4d0e-be0b-929ee443ad4c`} target="_self" onClick={closeModal} >
        <p>3.24.2 Project Documents Examples</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-a' to={`/posts/pmbok6_2_4_0/12af097f-8ae3-4e6b-85c2-bffc91d4051f`} target="_self" onClick={closeModal} >
        <p>4 Executing Process Group</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_2_4_1/a0b0c768-a7b5-4e26-8afa-09d859e7bfb4`} target="_self" onClick={closeModal} >
        <p>4.1 Direct And Manage Project Work</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_4_1.1/0c96924d-0268-4d57-a8b9-1471ba372c8c`} target="_self" onClick={closeModal} >
        <p>4.1.1 Project Management Plan Components</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_4_1.2/070b92b7-decd-4d32-b20d-a1610761501b`} target="_self" onClick={closeModal} >
        <p>4.1.2 Project Documents Examples</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_4_1.3/7eeca218-9fc9-499b-9221-ac70899b657d`} target="_self" onClick={closeModal} >
        <p>4.1.3 Project Management Plan Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_4_1.4/a98b0636-0be3-455f-8052-22f8ef38e03b`} target="_self" onClick={closeModal} >
        <p>4.1.4 Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_2_4_2/55d57430-bdd3-408e-8510-dcd917709b43`} target="_self" onClick={closeModal} >
        <p>4.2 Manage Project Knowledge</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_4_2.1/8dfc76a5-69e1-4fa9-b19b-51bbce041740`} target="_self" onClick={closeModal} >
        <p>4.2.1 Project Management Plan Components</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_4_2.2/4abf14fc-611d-4699-a21a-c710a5f3c9e6`} target="_self" onClick={closeModal} >
        <p>4.2.2 Project Documents Examples</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_4_2.3/1b40bc25-8ba0-4abe-aa63-26883d18da3c`} target="_self" onClick={closeModal} >
        <p>4.2.3 Project Management Plan Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_2_4_3/e3e1d895-28f3-4f3d-920a-190cafd50448`} target="_self" onClick={closeModal} >
        <p>4.3 Manage Quality</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_4_3.1/99b06a06-f874-47f3-b481-fa11b38dd54d`} target="_self" onClick={closeModal} >
        <p>4.3.1 Project Management Plan Components</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_4_3.2/b544d50d-a41f-4a1b-90f9-37867e14ff95`} target="_self" onClick={closeModal} >
        <p>4.3.2 Project Documents Examples</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_4_3.3/4d49ba8a-468d-4a1d-88ae-74044fb2015a`} target="_self" onClick={closeModal} >
        <p>4.3.3 Project Management Plan Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_4_3.4/dcfde8c5-f737-4db1-af7c-bbac6b069fbb`} target="_self" onClick={closeModal} >
        <p>4.3.4 Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_2_4_4/35bc1b25-5fdb-4c0e-b49f-b0bef51e8b16`} target="_self" onClick={closeModal} >
        <p>4.4 Acquire Resources</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_4_4.1/0eab8790-d4a2-4470-8089-5829af5aa700`} target="_self" onClick={closeModal} >
        <p>4.4.1 Project Management Plan Components</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_4_4.2/d563823d-75b1-48d4-a037-ba3d3c8215b1`} target="_self" onClick={closeModal} >
        <p>4.4.2 Project Documents Examples</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_4_4.3/5abd1530-3a3c-4df6-a3ef-d500a0013502`} target="_self" onClick={closeModal} >
        <p>4.4.3 Project Management Plan Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_4_4.4/905b8989-2054-4dde-87f6-e4ca9e751232`} target="_self" onClick={closeModal} >
        <p>4.4.4 Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_2_4_5/93f7f464-9aba-4e6b-8ae1-957d02ef48b7`} target="_self" onClick={closeModal} >
        <p>4.5 Develop Team</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_4_5.1/7bab9470-dc02-4ed2-a375-38bdaf70cf03`} target="_self" onClick={closeModal} >
        <p>4.5.1 Project Management Plan Components</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_4_5.2/abfa8aef-d306-48b8-be1e-b40fa248a8d2`} target="_self" onClick={closeModal} >
        <p>4.5.2 Project Documents Examples</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_4_5.3/ba1ad8b9-729f-4f5c-92a7-c81c4942f840`} target="_self" onClick={closeModal} >
        <p>4.5.3 Project Management Plan Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_4_5.4/012792fc-4f33-4280-9549-6ece4ded1b2d`} target="_self" onClick={closeModal} >
        <p>4.5.4 Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_2_4_6/fa874f6b-2b0f-4b96-a016-175dd7017170`} target="_self" onClick={closeModal} >
        <p>4.6 Manage Team</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_4_6.1/0be4ae9d-e64f-47d0-b127-07914a8f7ce0`} target="_self" onClick={closeModal} >
        <p>4.6.1 Project Management Plan Components</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_4_6.2/5e25f1b7-49f4-4850-b857-956bc581538a`} target="_self" onClick={closeModal} >
        <p>4.6.2 Project Documents Examples</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_4_6.3/5f474457-8700-431f-857e-bb87eec8cfb8`} target="_self" onClick={closeModal} >
        <p>4.6.3 Project Management Plan Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_4_6.4/4c912f82-ee5f-490d-b06a-941c877d221a`} target="_self" onClick={closeModal} >
        <p>4.6.4 Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_2_4_7/135b7d56-6ff8-4004-a901-701fa7693621`} target="_self" onClick={closeModal} >
        <p>4.7 Manage Communications</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_4_7.1/b9c13dcd-3888-4c66-a87d-2011261dfed6`} target="_self" onClick={closeModal} >
        <p>4.7.1 Project Management Plan Components</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_4_7.2/80d30c73-b98d-4b88-9534-fe7169343984`} target="_self" onClick={closeModal} >
        <p>4.7.2 Project Documents Example</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_4_7.3/60097791-c6dc-49fc-8ed1-c629b7b8a7ec`} target="_self" onClick={closeModal} >
        <p>4.7.3 Project Management Plan Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_4_7.4/730fdd7d-2196-4e60-bf99-74c524d12052`} target="_self" onClick={closeModal} >
        <p>4.7.4 Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_2_4_8/64ff9f99-c223-4f79-9161-49513b3a5984`} target="_self" onClick={closeModal} >
        <p>4.8 Implement Risk Responses</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_4_8.1/d3fafd65-5140-4762-97ce-369d76e5797a`} target="_self" onClick={closeModal} >
        <p>4.8.1 Project Management Plan Components</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_4_8.2/6e252dc1-5158-4fc0-838d-617445adccba`} target="_self" onClick={closeModal} >
        <p>4.8.2 Project Documents Examples</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_4_8.3/6fd51c1e-7cee-4e89-8cb4-492c2615d66a`} target="_self" onClick={closeModal} >
        <p>4.8.3 Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_2_4_9/744f9acd-ecda-402f-b1c8-d8c99f8ac114`} target="_self" onClick={closeModal} >
        <p>4.9 Conduct Procurements</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_4_9.1/6c35e6a4-9650-4852-b44b-af9ff0d80431`} target="_self" onClick={closeModal} >
        <p>4.9.1 Project Management Plan Components</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_4_9.2/50368b57-5717-4ac4-8570-7acd34480ddd`} target="_self" onClick={closeModal} >
        <p>4.9.2 Project Documents Examples</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_4_9.3/347a3a1a-aca5-4628-9297-1e7d0c6fd98f`} target="_self" onClick={closeModal} >
        <p>4.9.3 Project Management Plan Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_4_9.4/389860ae-3b23-4725-a0e4-88e640c81e22`} target="_self" onClick={closeModal} >
        <p>4.9.4 Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_2_4_10/67ef7b35-cc1d-462b-93fc-2740347ab6b4`} target="_self" onClick={closeModal} >
        <p>4.10 Manage Stakeholder Engagement</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_4_10.1/7e6b183e-9e7c-45d5-8f43-8c105044a8e9`} target="_self" onClick={closeModal} >
        <p>4.10.1 Project Management Plan Components</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_4_10.2/f0f579f2-414c-42c8-a39d-30470f66cc63`} target="_self" onClick={closeModal} >
        <p>4.10.2 Project Documents Examples</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_4_10.3/781a26ca-a9e4-448c-a120-4c1f522bc412`} target="_self" onClick={closeModal} >
        <p>4.10.3 Project Management Plan Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_4_10.4/62e3eafb-2319-40ff-89a0-a7d40b3adc0f`} target="_self" onClick={closeModal} >
        <p>4.10.4 Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-a' to={`/posts/pmbok6_2_5_0/816a1525-48f4-4e6a-92f5-0aadde972c98`} target="_self" onClick={closeModal} >
        <p>5 Monitoring And Controlling Process Group</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_2_5_1/494f6944-ab43-4cd7-bc46-ecdf4598b99f`} target="_self" onClick={closeModal} >
        <p>5.1 Monitor And Control Project Work</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_5_1.1/d8f0d57e-4481-49c8-829b-607e8661a584`} target="_self" onClick={closeModal} >
        <p>5.1.1 Project Management Plan Components</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_5_1.2/88428a97-a6b9-44d4-b749-98a50d73efb8`} target="_self" onClick={closeModal} >
        <p>5.1.2 Project Documents Examples</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_5_1.3/1b277f02-17a2-47b1-8b32-157156d1294e`} target="_self" onClick={closeModal} >
        <p>5.1.3 Project Management Plan Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_5_1.4/43389269-d8e1-4566-836f-f650fb7f460a`} target="_self" onClick={closeModal} >
        <p>5.1.4 Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_2_5_2/b65f2608-f9e0-4194-b1ff-1105094228df`} target="_self" onClick={closeModal} >
        <p>5.2 Perform Integrated Change Control</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_5_2.1/b5a880de-4e5c-4c23-a67e-9e56c9046419`} target="_self" onClick={closeModal} >
        <p>5.2.1 Project Management Plan Components</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_5_2.2/0209e3f3-4b75-4884-8079-ecae3f39a539`} target="_self" onClick={closeModal} >
        <p>5.2.2 Project Documents Examples</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_5_2.3/a69176c3-7094-4566-ba88-605e49850006`} target="_self" onClick={closeModal} >
        <p>5.2.3 Project Management Plan Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_5_2.4/9026aa14-ae80-4277-ac9c-bdfb14abe058`} target="_self" onClick={closeModal} >
        <p>5.2.4 Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_2_5_3/e3830604-9d62-47ac-939f-2b53b9318fc9`} target="_self" onClick={closeModal} >
        <p>5.3 Validate Scope</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_5_3.1/75e9888c-c40b-46b8-807c-226b64887e38`} target="_self" onClick={closeModal} >
        <p>5.3.1 Project Management Plan Components</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_5_3.2/da2bc532-27dc-4a79-ae5c-bf8d535da61d`} target="_self" onClick={closeModal} >
        <p>5.3.2 Project Documents Examples</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_5_3.3/32c458b5-abad-4ba5-9fc3-828de9f61162`} target="_self" onClick={closeModal} >
        <p>5.3.3 Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_2_5_4/a88fd087-3f91-4662-a176-f70854a80058`} target="_self" onClick={closeModal} >
        <p>5.4 Control Scope</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_5_4.1/e6978b2a-b8e7-41e1-b787-350a47013bf8`} target="_self" onClick={closeModal} >
        <p>5.4.1 Project Management Plan Components</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_5_4.2/e69a9b8a-a786-4e30-b612-050d53c1bae6`} target="_self" onClick={closeModal} >
        <p>5.4.2 Project Documents Examples</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_5_4.3/5d896dab-953a-4484-901f-45c466d0370a`} target="_self" onClick={closeModal} >
        <p>5.4.3 Project Management Plan Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_5_4.4/e4196a71-421e-4bbc-be80-e1249ead705b`} target="_self" onClick={closeModal} >
        <p>5.4.4 Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_2_5_5/e185d3c9-2e76-4090-86e5-f86f0dcdd51e`} target="_self" onClick={closeModal} >
        <p>5.5 Control Schedule</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_5_5.1/0a6dc278-8688-4ee2-87a0-000ef315ee79`} target="_self" onClick={closeModal} >
        <p>5.5.1 Project Management Plan Components</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_5_5.2/e6308aa0-888b-4e52-9e27-80e05b54f685`} target="_self" onClick={closeModal} >
        <p>5.5.2 Project Documents Examples</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_5_5.3/416c4725-9ed8-4309-9b3e-e4a391360c7e`} target="_self" onClick={closeModal} >
        <p>5.5.3 Project Management Plan Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_5_5.4/54cdc2f9-e581-453a-9a55-4c8fb8b8bebd`} target="_self" onClick={closeModal} >
        <p>5.5.4 Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_2_5_6/5bc10227-1d04-4cda-8602-b53bce78ff3a`} target="_self" onClick={closeModal} >
        <p>5.6 Control Costs</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_5_6.1/5bef188e-044f-4b91-90eb-22d19d96f6f8`} target="_self" onClick={closeModal} >
        <p>5.6.1 Project Management Plan Components</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_5_6.2/74856e91-c7f3-4224-9b1c-0d3efdfecfdb`} target="_self" onClick={closeModal} >
        <p>5.6.2 Project Documents Examples</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_5_6.3/b35d52ec-d2f5-4ac2-bc22-b4bad9ece2c8`} target="_self" onClick={closeModal} >
        <p>5.6.3 Project Management Plan Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_5_6.4/440f9458-e62b-4c62-953a-18925502f76b`} target="_self" onClick={closeModal} >
        <p>5.6.4 Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_2_5_7/956280d5-3701-4bf2-89f9-2111cbb93de4`} target="_self" onClick={closeModal} >
        <p>5.7 Control Quality</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_5_7.1/9cfe0e87-8f30-4192-b8a5-3eef08ed9399`} target="_self" onClick={closeModal} >
        <p>5.7.1 Project Management Plan Components</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_5_7.2/930e2bd3-7226-453a-b50f-42bec663e213`} target="_self" onClick={closeModal} >
        <p>5.7.2 Project Documents Examples</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_5_7.3/c8178edc-5c34-4175-8f0f-a721639d1ad6`} target="_self" onClick={closeModal} >
        <p>5.7.3 Project Management Plan Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_5_7.4/8b3976d9-b866-47fc-b8eb-e9138d5a80c7`} target="_self" onClick={closeModal} >
        <p>5.7.4 Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_2_5_8/2039b324-c58d-44d5-b809-2b804ccc895d`} target="_self" onClick={closeModal} >
        <p>5.8 Control Resources</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_5_8.1/aceef648-2bd1-40f2-a42f-8294959a595f`} target="_self" onClick={closeModal} >
        <p>5.8.1 Project Management Plan Components</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_5_8.2/ff2dbe1b-f011-466b-a086-62f81c2f7a56`} target="_self" onClick={closeModal} >
        <p>5.8.2 Project Documents Examples</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_5_8.3/8cd27f93-9699-4756-8ac1-945d45577af5`} target="_self" onClick={closeModal} >
        <p>5.8.3 Project Management Plan Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_5_8.4/bfb70d18-06e9-4d42-9ffc-047fc4ddca08`} target="_self" onClick={closeModal} >
        <p>5.8.4 Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_2_5_9/ea1507ee-7441-4406-9165-b8f9b114eefb`} target="_self" onClick={closeModal} >
        <p>5.9 Monitor Communications</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_5_9.1/924999c4-693f-49c5-9877-5238ca7f3cfc`} target="_self" onClick={closeModal} >
        <p>5.9.1 Project Management Plan Components</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_5_9.2/0424849b-ddb5-4f89-897c-e9d4c439fb1e`} target="_self" onClick={closeModal} >
        <p>5.9.2 Project Documents Examples</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_5_9.3/d161ad09-f9ec-4002-8687-4b822b13958e`} target="_self" onClick={closeModal} >
        <p>5.9.3 Project Management Plan Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_5_9.4/5d839c16-b73b-492a-9b46-93a71da11ee5`} target="_self" onClick={closeModal} >
        <p>5.9.4 Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_2_5_10/5ce3bc93-5161-4f0e-90f7-20a6b2965670`} target="_self" onClick={closeModal} >
        <p>5.10 Monitor Risks</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_5_10.1/edc5b1d5-f707-4f93-a677-3c041134f51a`} target="_self" onClick={closeModal} >
        <p>5.10.1 Project Management Plan Components</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_5_10.2/0d64a3ff-a1f5-4fbf-8ed5-df461a1ff97d`} target="_self" onClick={closeModal} >
        <p>5.10.2 Project Documents Examples</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_5_10.3/1b74621c-447d-45bf-8d61-6fd3d3a8684f`} target="_self" onClick={closeModal} >
        <p>5.10.3 Project Management Plan Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_5_10.4/eb7c2a31-b869-40df-b0c1-ba4bce8f0d08`} target="_self" onClick={closeModal} >
        <p>5.10.4 Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_2_5_11/48d490a1-db02-466e-a7fd-5abc631a48e2`} target="_self" onClick={closeModal} >
        <p>5.11 Control Procurements</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_5_11.1/b44d38d2-7829-452b-8585-66d61653f287`} target="_self" onClick={closeModal} >
        <p>5.11.1 Project Management Plan Components</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_5_11.2/2bd298cc-c644-4af1-8212-6fef0cf1bc6e`} target="_self" onClick={closeModal} >
        <p>5.11.2 Project Documents Examples</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_5_11.3/761a98ee-11c9-4f2a-9837-27a24bc7dd71`} target="_self" onClick={closeModal} >
        <p>5.11.3 Project Management Plan Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_5_11.4/183b4802-d631-4e15-bdab-2a2763723612`} target="_self" onClick={closeModal} >
        <p>5.11.4 Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_2_5_12/97c73c30-1fe5-4e95-af51-6a63b7e2d128`} target="_self" onClick={closeModal} >
        <p>5.12 Monitor Stakeholder Engagement</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_5_12.1/1f33e6b6-3794-416a-80c0-3a42fe660bab`} target="_self" onClick={closeModal} >
        <p>5.12.1 Project Management Plan Components</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_5_12.2/3f861857-46a8-4b8b-b6d1-8c1a7d65a6d0`} target="_self" onClick={closeModal} >
        <p>5.12.2 Project Documents Examples</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_5_12.3/ac0c387c-0814-4a03-a697-3e23107d1ddb`} target="_self" onClick={closeModal} >
        <p>5.12.3 Project Management Plan Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_5_12.4/45d2bacf-f92f-4a81-899b-1c28e705180f`} target="_self" onClick={closeModal} >
        <p>5.12.4 Project Documents Updates</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-a' to={`/posts/pmbok6_2_6_0/cdaec389-4c5b-4842-83e6-b9dd1dea2b81`} target="_self" onClick={closeModal} >
        <p>6 Closing Process Group</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-b' to={`/posts/pmbok6_2_6_1/ebd9c6e4-1719-4c41-8bc4-0aae806d5fc9`} target="_self" onClick={closeModal} >
        <p>6.1 Close Project Or Phase</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_6_1.1/368cd086-b118-4614-8fdb-756c6f91aefa`} target="_self" onClick={closeModal} >
        <p>6.1.1 Project Management Plan Components</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_6_1.2/cbde1a4d-1e67-4d43-9b0d-50ea77628769`} target="_self" onClick={closeModal} >
        <p>6.1.2 Project Documents Examples</p>
      </Link>
      <br />
      <Link className='inline-block resource-sub-fragment level-c' to={`/posts/pmbok6_2_6_1.3/2ffdfaa4-c229-4481-905c-181f75af3959`} target="_self" onClick={closeModal} >
        <p>6.1.3 Project Documents Updates</p>
      </Link>
      <br />
    </div>
  );
};

export default PmbokSevenToc;
